import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Basic resources inline for first pass. You can later split into JSON files.
const resources = {
  fr: {
    translation: {
      breadcrumb: {
        home: 'Accueil'
      },
      seo: {
        home: {
          title: 'FIVEMSHIELD | Protection DDoS & Hébergeur pour serveur FiveM - Assistance 24/7',
          description:
            "FIVEMSHIELD: hébergeur FiveM spécialisé avec protection Anti-DDoS, VPS haute fréquence, stockage NVMe et support 24/7. Protégez votre serveur contre les attaques L3/L4/L7."
        }
      },
      header: {
        logoAria: 'FIVEMSHIELD - Hébergeur et protection Anti-DDoS pour serveurs FiveM',
        nav: {
          home: 'Accueil',
          services: 'Services',
          about: 'À propos',
          cfxFinder: 'CFX Finder',
          blog: 'Blog',
          contact: 'Contact',
          protection: 'Status',
          login: 'Se connecter'
        },
        services: {
          vps: { title: 'VPS Game', desc: 'Serveurs VPS optimisés pour FiveM' },
          proxy: { title: 'Reverse Proxy', desc: 'Soyez protégé chez n\'importe quel hébergeur' },
          cdn: { title: 'CDN & Caching', desc: 'Accélération des resources' },
          vpsWindows: { title: 'VPS Windows', desc: 'Serveurs VPS Windows' },
          antiDdos: { title: 'Anti-DDoS FiveM', desc: 'Protection dédiée FiveM' }
        },
        mobile: {
          support: 'Support 24/7 disponible',
          getProtection: 'Obtenir une protection'
        },
        language: {
          label: 'Langue',
          fr: 'FR',
          en: 'EN'
        }
      },
      hero: {
        brand: 'FIVEMSHIELD',
        antiDDoS: 'Anti-DDoS',
        fiveM: ' FiveM',
        tagline:
          '',
        cta: {
          getProtection: 'Obtenir une protection',
          learnMore: 'En savoir plus'
        },
        features: {
          l3l7: 'L3-L7 Protection',
          lowLatency: 'Faible Latence',
          globalNetwork: 'Réseau Global'
        },
        scroll: 'SCROLLEZ',
        stats: { capacity: 'CAPACITÉ', avgLatency: 'LATENCE MOYENNE' }
      },
      common: {
        perMonth: '/mois',
        perLifetime: '/à vie',
        billing: {
          monthly: {
            label: 'Mensuel',
            suffix: '/mois',
            description: 'Sans engagement'
          },
          quarterly: {
            label: 'Trimestriel',
            suffix: '/3 mois',
            description: 'Économisez 5 %'
          },
          semiannual: {
            label: 'Semestriel',
            suffix: '/6 mois',
            description: 'Économisez 10 %'
          },
          annual: {
            label: 'Annuel',
            suffix: '/an',
            description: 'Jusqu’à 18 % d’économie'
          },
          monthlyEquivalent: 'Soit {{price}} / mois'
        }
      },
      banner: {
        highlight: 'Reverse Proxy',
        product: 'Anti-DDoS FiveM',
        urgency: 'Offre limitée',
        description: 'Votre serveur FiveM, protégé en moins de 2 minutes. Anti-DDoS 17+ Tbps, IP masquée, zéro latence — activez la protection maintenant.',
        originalPrice: '39,99€/mois',
        fromPrice: 'Dès 33,99€/mois',
        codeLabel: 'Code promo',
        code: 'PROXY15',
        cta: 'Commander avec -15%',
        secondaryCta: 'Voir les tarifs Reverse Proxy →',
        later: 'Plus tard',
        close: 'Fermer la promotion'
      },
      trust: {
        validatedBy: 'Validé par {{count}} serveurs à travers le monde'
      },
      locations: {
        title: 'Nos Points de Présence',
        note: ''
      },
      stats: {
        mitigationCapacity: 'Capacité de mitigation',
        uptime: 'Uptime garanti',
        addedLatency: 'Latence ajoutée',
        pops: 'Points de présence'
      },
      features: {
        badge: 'Suite Anti-DDoS FiveM',
        title: 'Pourquoi nous choisir ?',
        subtitle: "Une protection pensée pour FiveM, sans compromis sur la performance ni l’expérience joueur.",
        cta: 'Découvrir nos offres',
        metrics: [
          { value: '10 Tbps', label: 'Capacité globale de mitigation' },
          { value: '<15 ms', label: 'Latence moyenne EU' },
          { value: '24/7', label: 'SOC & support prioritaire' }
        ],
        items: {
          l3l4l7: {
            title: 'Protection L3/L4/L7 dédiée FiveM',
            description: 'Mitigation avancée des attaques L7 ciblant /info.json, /players.json ... Et trafic TCP & UDP FiveM.'
          },
          lowLatency: {
            title: 'Ultra-faible latence',
            description: 'Routage Anycast pour un ping stable, même sous mitigation.'
          },
          pops: {
            title: 'PoPs internationaux',
            description: 'Réseau mondial, proximité joueurs, acheminement intelligent pour performances maximales.'
          },
          supportCard: {
            title: 'Support 24/7 prioritaire',
            description: 'Experts FiveM joignables en continu, résolution rapide, accompagnement pro.'
          },
          redundant: {
            title: 'Infra redondante',
            description: 'Scrubbing centers, basculement automatique et haute-disponibilité garantie.'
          },
          instant: {
            title: 'Déploiement instantané',
            description: 'Activation immédiate, règles prêtes à l’emploi, compatible ressources majeures.'
          }
        },
        support: {
          standard: {
            badge: 'Support Standard',
            title: 'Support Standard',
            description: 'Notre équipe de support standard est disponible pour répondre à vos questions et résoudre vos problèmes.',
            bullets: [
              'Disponible de 11:00 à 22:00 (UTC)',
              'Assistance technique par E-mail et Ticket',
              'Temps de réponse moyen : 1 à 2 heures'
            ],
            footer: 'Inclus avec toutes nos offres standard'
          },
          premium: {
            badge: 'Support Premium',
            title: 'Support Premium 24/7',
            description: 'Une assistance prioritaire disponible 24/7 pour un support ultra-rapide et personnalisé.',
            bullets: [
              'Disponible 24/7, 365 jours par an',
              'Assistance prioritaire par ticket et chat',
              'Temps de réponse moyen : 5 minutes'
            ],
            footer: 'Disponible en option'
          }
        },
        infra: [
          {
            title: 'Support dédié',
            description: 'Escalade directe vers nos ingénieurs SOC pour les incidents critiques.'
          },
          {
            title: 'Infra redondante',
            description: 'Scrubbing centers, basculement automatique, haute dispo.'
          },
          {
            title: 'Playbooks personnalisés',
            description: 'Runbooks et automatisations adaptés à vos événements.'
          }
        ]
      },
      diagram: {
        incoming: 'Trafic entrant',
        ddosAnalysis: 'Analyse DDoS',
        filtering: 'Filtrage & Nettoyage',
        loadBalancing: 'Load Balancing',
        fivemServer: 'Serveur FiveM'
      },
      partnersBanner: {
        poweredBy: 'Propulsé par les meilleures technologies'
      },
      footer: {
        description:
          'Fournisseur de solutions de sécurité haut de gamme pour les serveurs FiveM. Protégez votre communauté avec notre protection DDoS avancée.',
        quickLinks: {
          title: 'Liens Rapides',
          home: 'Accueil',
          about: 'À Propos',
          legal: 'CGU/CGV',
          privacy: 'Politique de Confidentialité',
          contact: 'Contact'
        },
        services: {
          title: 'Nos Services',
          reverseProxy: 'Reverse Proxy',
          vps: 'VPS',
          cdn: 'CDN & Caching',
          panel: 'Game Panel'
        },
        contact: {
          title: 'Contactez-Nous',
          discordJoin: 'Rejoindre notre Discord'
        },
        copyright: 'Tous droits réservés.'
      },
      contactPage: {
        breadcrumb: 'Contact',
        seo: {
          title: 'Contact | FIVEMSHIELD',
          description: "Contactez FIVEMSHIELD via Discord, WhatsApp ou depuis l'Espace Client pour toute question sur l'hébergement FiveM et la protection Anti-DDoS."
        },
        hero: {
          title: 'Parlons de',
          titleHighlight: 'votre projet.',
          subtitle: "Que vous ayez une question technique, besoin d'aide avec votre serveur ou une demande commerciale, notre équipe est disponible et réactive."
        },
        trust: [
          { value: '<15 min', label: 'Temps de réponse moyen' },
          { value: '24/7', label: 'Disponibilité support' },
          { value: '450+', label: 'Serveurs protégés' }
        ],
        cards: {
          discord: {
            title: 'Discord',
            description: 'Rejoignez notre communauté de plus de 1000 membres. Support communautaire, annonces et échanges avec notre équipe.',
            action: 'Rejoindre le serveur',
            response: 'Réponse en ~15 min'
          },
          support: {
            title: 'Espace Client',
            description: 'Ouvrez un ticket pour toute demande technique approfondie ou liée à la facturation de votre compte.',
            action: 'Ouvrir un ticket',
            response: 'Réponse en ~1h'
          },
          whatsapp: {
            title: 'WhatsApp',
            description: 'Contactez-nous directement pour une réponse rapide ou pour toute demande commerciale urgente.',
            action: 'Envoyer un message',
            response: 'Réponse en ~30 min'
          }
        },
        faq: {
          title: 'Questions fréquentes',
          items: [
            { question: 'Quel est le meilleur moyen de vous contacter ?', answer: 'Pour un support rapide, ouvrez un ticket sur Discord. Pour les questions commerciales, privilégiez WhatsApp ou un ticket dans votre Espace Client.' },
            { question: 'Quels sont vos délais de réponse ?', answer: 'Notre temps de réponse moyen est inférieur à 15 minutes sur Discord. Les tickets dans l\'Espace Client sont traités en moins d\'une heure.' },
            { question: 'Proposez-vous un accompagnement pour la mise en place ?', answer: 'Oui, notre équipe vous accompagne gratuitement dans la configuration de votre protection et de vos services.' }
          ]
        },
        links: {
          discover: 'Découvrir aussi :',
          vps: 'VPS FiveM',
          reverse: 'Reverse Proxy',
          about: 'À propos de nous'
        }
      },
      about: {
        breadcrumb: 'À propos',
        seo: {
          title: 'À propos de FIVEMSHIELD | Notre Histoire & Équipe',
          description: "Découvrez l'histoire de FIVEMSHIELD, de la première idée à la protection de centaines de serveurs FiveM. Rencontrez l'équipe derrière la meilleure protection Anti-DDoS FiveM."
        },
        hero: {
          kicker: 'Notre Histoire',
          title: 'Nés du chaos.',
          titleHighlight: 'Construits pour protéger.',
          subtitle: "Tout a commencé par des serveurs crashés et des joueurs déconnectés. Personne ne protégeait FiveM correctement. Alors on l'a fait nous-mêmes."
        },
        story: {
          chapter1: {
            kicker: 'L\'origine',
            year: '2023',
            title: 'Une frustration devenue mission',
            paragraphs: [
              "En 2023, Lucas et Théo gèrent leurs propres serveurs FiveM. Chaque semaine, c'est la même histoire : des attaques DDoS paralysent leurs communautés pendant des heures. Les solutions existantes ? Trop chères, trop lentes, pas adaptées à FiveM.",
              "Ce jour-là, ils prennent une décision qui va tout changer : construire la protection que personne ne propose. Une solution pensée de A à Z pour FiveM."
            ]
          },
          chapter2: {
            kicker: 'La technologie',
            year: '2024',
            title: 'XDP, eBPF et filtrage kernel-bypass',
            paragraphs: [
              "Là où d'autres posent un CDN et appellent ça de la protection, on a écrit notre propre moteur de mitigation. Basé sur XDP et eBPF, il filtre les paquets au niveau du kernel-bypass à plus de 100 millions de paquets par seconde.",
              "Chaque flux FiveM est inspecté de manière stateful. On comprend le protocole, on sait différencier un joueur légitime d'un DDoS. Résultat : zéro faux positif, zéro latence ajoutée."
            ]
          },
          chapter3: {
            kicker: 'L\'expansion',
            year: '2024-2025',
            title: '17+ Tbps, BGP Anycast, multi-PoP',
            paragraphs: [
              "Notre réseau a grandi. Scrubbing centers en Europe, routage BGP Anycast pour diriger le trafic vers le nœud le plus proche. Plus de 17 Tbps de capacité d'absorption.",
              "Puis les VPS. Le Panel 1-clic. Le CDN & Caching. Chaque brique a été construite avec la même obsession : que vos joueurs ne remarquent jamais qu'il y avait une attaque."
            ]
          }
        },
        stats: {
          servers: { value: '450+', label: 'Serveurs protégés' },
          capacity: { value: '17+ Tbps', label: 'Capacité de mitigation' },
          latency: { value: '<10 ms', label: 'Latence moyenne EU' },
          uptime: { value: '99,99%', label: 'Disponibilité SLA' }
        },
        values: {
          kicker: 'Nos valeurs',
          title: 'Ce en quoi on croit',
          items: [
            { title: 'Transparence', description: 'Pas de bullshit marketing. On dit ce qu\'on fait, on fait ce qu\'on dit. Nos stats sont réelles, nos promesses tenues.' },
            { title: 'Performance', description: 'Chaque milliseconde compte. Notre infrastructure est optimisée pour que vos joueurs ne ressentent jamais la protection.' },
            { title: 'Innovation', description: 'On ne copie pas les solutions existantes. On développe nos propres technologies, en interne, adaptées spécifiquement à FiveM.' },
            { title: 'Communauté', description: 'On est des joueurs avant tout. On protège FiveM parce qu\'on aime FiveM. Chaque décision est guidée par la communauté.' }
          ]
        },
        team: {
          kicker: 'L\'équipe',
          title: 'Les visages derrière le bouclier',
          subtitle: 'Deux passionnés de cybersécurité et de FiveM qui ont décidé de changer les règles du jeu.',
          members: {
            lucas: {
              role: 'Fondateur & PDG',
              description: "Expert en sécurité réseau avec plus de 6 ans d'expérience. Lucas a architecturé l'ensemble de l'infrastructure FIVEMSHIELD et dirige la vision produit."
            },
            theo: {
              role: 'Ingénieur Anti-DDoS',
              description: "L'homme derrière notre moteur de mitigation XDP/eBPF. Théo développe et optimise les algorithmes qui protègent vos serveurs en temps réel."
            }
          }
        },
        cta: {
          title: 'Prêt à sécuriser votre serveur ?',
          subtitle: "Rejoignez les centaines de serveurs qui nous font confiance. Protection activée en quelques minutes.",
          primary: 'Découvrir nos services',
          secondary: 'Nous contacter'
        },
        links: {
          discover: 'Découvrez nos services :'
        }
      },
      vps: {
        breadcrumb: 'VPS FiveM',
        seo: {
          title: 'VPS FiveM Haute Fréquence | Anti-DDoS Inclus | FIVEMSHIELD',
          description: 'VPS optimisés FiveM avec CPU 5.20GHz, NVMe ultra-rapide et protection Anti-DDoS intégrée. Idéal pour 50 à 150+ joueurs.'
        },
        hero: {
          kicker: 'Hébergement premium FiveM',
          title: 'VPS FiveM & Anti-DDoS',
          subtitle:
            'CPU 5.20GHz, stockage NVMe Gen4, protection L3/L4/L7 propriétaire et support prioritaire pour garder votre communauté en ligne quoi qu’il arrive.',
          badges: {
            dedicated: 'Anti-DDoS spécial FiveM',
            uptime: 'SLA 99,95 %',
            support: 'Support prioritaire 24/7'
          },
          checklist: [
            'Activation instantanée via notre manager sécurisé',
            'Migration guidée par des ingénieurs réseau',
            'Monitoring temps réel & alertes proactives'
          ],
          highlights: {
            players: { value: '450+', label: 'serveurs FiveM protégés' },
            latency: { value: '<10 ms', label: 'latence moyenne EU' },
            mitigation: { value: '17+ Tbps', label: 'capacité de mitigation globale' }
          },
          rating: {
            value: '4.9/5',
            caption: '87 avis vérifiés · 450+ serveurs protégés'
          },
          priceFrom: {
            value: 'Dès 39,99€',
            suffix: '/mois — sans engagement'
          },
          guarantees: [
            'Activation en 5 minutes',
            'Résiliable à tout moment',
            'Anti-DDoS inclus'
          ],
          ticker: {
            label: 'Requêtes filtrées en direct'
          },
          ctaOrderNow: 'Commander maintenant',
          ctaSeeOffers: 'Voir les offres',
          ctaTalk: 'Parler à un expert',
          liveBadge: 'Système opérationnel',
          imageAlt: 'VPS FiveM haute performance'
        },
        trustBar: [
          'Déploiement immédiat',
          'Anti-DDoS L3/L4/L7',
          'Uptime 99.998%',
          'Réseau 10 PoP',
          'Support 24/7',
          'IP masquée'
        ],
        trust: {
          title: 'Choisi par les plus grandes communautés roleplay FiveM',
          subtitle:
            'Nous travaillons avec les plus gros serveurs Francophones & Espagnoles.'
        },
        plans: {
          pretitle: 'Hébergement + protection',
          title: 'Nos offres VPS FiveM',
          subtitle: 'Choisissez la configuration adaptée à la taille de votre communauté.',
          recommended: 'RECOMMANDÉ',
          select: 'Choisir cette offre',
          outOfStock: 'RUPTURE DE STOCK',
          outOfStockCta: 'Indisponible',
          includes: 'Inclus dans toutes les offres :',
          globalFeatures: [
            'Protection Anti-DDoS L3/L4/L7 calibrée FiveM',
            'Bande passante 25 Gbit/s + monitoring en temps réel',
            'Dashboard & API FIVEMSHIELD',
          ],
          ddosUpgrade: {
            title: 'Protection DDoS Ultra',
            price: '30€',
            description: 'Ajoutez une protection DDoS Ultra à votre VPS pour une sécurité renforcée. Les offres standards incluent déjà une bonne protection, mais cette option offre une efficacité maximale contre les attaques les plus sophistiquées.',
            badge: 'Option disponible',
            features: [
              'Filtrage comportemental avancé',
              'Absorption des attaques les plus sophistiquées',
              'Activation immédiate'
            ]
          },
          core: {
            badge: 'Essentiel',
            price: '19,99€',
            description: 'Idéal pour lancer votre communauté RP jusqu’à 30 joueurs simultanés.',
            features: [
              '4 vCore AMD R9 7950X3D @ 5.20GHz',
              '8 Go RAM DDR5 ECC',
              '40 Go NVMe Gen4',
              'Trafic illimité / 25 Gbit/s',
              'Support standard 7j/7'
            ]
          },
          stealth: {
            badge: 'Croissance',
            price: '39,99€',
            description: 'Le bon calibrage pour une communauté RP de 30 à 80 joueurs en pleine croissance.',
            features: [
              '6 vCore AMD R9 7950X3D @ 5.20GHz',
              '16 Go RAM DDR5 ECC',
              '80 Go NVMe Gen4',
              'Protection DDoS Stade 1',
              'Support prioritaire & monitoring 24/7'
            ]
          },
          storm: {
            badge: 'Haute affluence',
            price: '59,99€',
            description: 'Taillé pour les serveurs RP de 80 à 150 joueurs avec forte affluence.',
            features: [
              '8 vCore AMD R9 7950X3D @ 5.20GHz',
              '32 Go RAM DDR5 ECC',
              '120 Go NVMe Gen4',
              'Protection DDoS Stade 2',
              'Advisor technique dédié'
            ]
          },
          titan: {
            badge: 'Enterprise',
            price: '99,99€',
            description: 'Pensé pour les réseaux multi-serveurs et les communautés de 150+ joueurs.',
            features: [
              '12 vCore AMD R9 7950X3D @ 5.20GHz',
              '42 Go RAM DDR5 ECC',
              '240 Go NVMe Gen4',
              'Protection DDoS Stade 2',
              'Support TAM 24/7 & SLA contractuel'
            ]
          },
          contact: 'Besoin d’une configuration bare-metal ou multi-VPS ?',
          contactCta: 'Contacter le service commercial'
        },
        features: {
          title: 'Des performances pensées pour FiveM',
          subtitle:
            'CPU haute fréquence, NVMe Gen4 et réseau 25 Gbit/s protégés par notre SOC pour un serveur stable même sous attaque.',
          items: {
            cpu: {
              title: 'CPU haute fréquence dédiés',
              description: 'Nœuds AMD R9 7950X3D @ 5.20GHz isolés par cgroups afin de garantir la meilleure boucle serveur.'
            },
            storage: {
              title: 'Stockage NVMe Gen4',
              description: 'IOPS ultra élevés pour charger instantanément ressources et bases de données de votre RP.'
            },
            network: {
              title: 'Réseau 25 Gbit/s segmenté',
              description: 'Peering premium, BGP Anycast et routage optimisé vers la scène FiveM européenne.'
            },
            shield: {
              title: 'Bouclier Anti-DDoS propriétaire',
              description: 'Profiling comportemental sur /players.json, handshake TCP/UDP et filtrage L7 adaptatif.'
            }
          }
        },
        stack: {
          title: 'Suite de protection FIVEMSHIELD',
          subtitle: 'Un pipeline complet de filtrage et d’observabilité dédié aux mécaniques FiveM.',
          description: 'Chaque offre VPS inclut nos modules avancés pour analyser, filtrer et visualiser votre trafic.',
          cards: [
            {
              title: 'Filtrage comportemental L7',
              description: 'Signature dynamique sur /info.json, /players.json et endpoints sensibles FiveM.'
            },
            {
              title: 'Scrubbing distribué 10 Tbps',
              description: 'Centres multi-régions capables d’absorber les attaques volumétriques et applicatives.'
            },
            {
              title: 'Dashboard & alerting',
              description: 'Metrics temps réel, webhooks Discord et export API pour vos outils internes.'
            }
          ]
        },
        support: {
          title: 'Accompagnement opérationnel',
          subtitle: 'Un partenaire plutôt qu’un simple hébergeur.',
          description:
            'Nos ingénieurs réseau suivent vos pics de charge, préparent vos événements et escaladent vers le SOC si nécessaire.',
          badge: 'Support prioritaire & escalade SOC',
          items: [
            {
              title: 'Onboarding personnalisé',
              description: 'Checklist de durcissement, configuration txAdmin/CFX et optimisation des scripts critiques.'
            },
            {
              title: 'Observabilité proactive',
              description: 'Alertes latence, CPU et attaques envoyées sur votre canal préféré.'
            },
            {
              title: 'Gestion d’incidents 24/7',
              description: 'Escalade directe vers un ingénieur lorsque votre serveur est ciblé ou saturé.'
            }
          ]
        },
        faq: {
          title: 'Questions fréquentes sur nos VPS FiveM',
          subtitle: 'Tout ce qu’il faut savoir avant de migrer chez FIVEMSHIELD.',
          items: [
            {
              question: 'Quelle offre choisir selon mon serveur FiveM ?',
              answer:
                'StealthEdge convient aux communautés de 30 à 80 joueurs, StormGuard sécurise les serveurs de 80 à 150 joueurs et TitanShield s’adresse aux réseaux multi-instances de 150+ joueurs. Toutes les offres partagent la même protection Anti-DDoS propriétaire.'
            },
            {
              question: 'Comment garantissez-vous une faible latence ?',
              answer:
                'Nous utilisons des nœuds AMD 5.20GHz situés à Paris avec peering premium, un routage Anycast et un monitoring continu pour maintenir un ping <15 ms sur la zone EU.'
            },
            {
              question: 'La protection Anti-DDoS est-elle incluse ?',
              answer:
                'Oui, la mitigation L3/L4/L7 est incluse sans supplément. Elle filtre les requêtes ciblant les endpoints FiveM et absorbe jusqu’à 10 Tbps d’attaques.'
            },
            {
              question: 'Puis-je migrer mon serveur existant ?',
              answer:
                'Bien sûr. Notre équipe importe vos sauvegardes txAdmin/CFX, teste les ressources critiques et bascule votre communauté sans interruption.'
            }
          ]
        },
        cta: {
          badge: 'Prêt à démarrer ?',
          title: 'Lancez votre serveur FiveM blindé en moins de 10 minutes',
          subtitle: 'Commandez en ligne ou planifiez un call avec un ingénieur solution.',
          primary: 'Créer mon VPS maintenant',
          primaryDesc: 'Configuration guidée, activation en quelques minutes.',
          secondary: 'Planifier un appel',
          secondaryDesc: 'Échangez avec un ingénieur solution avant de vous engager.'
        }
      },
      vpsWindows: {
        seo: {
          title: 'VPS Windows dès 64,99€ | Windows Server 2025 + Anti-DDoS',
          description: 'VPS Windows FiveM : CPU 4.2GHz, NVMe, Windows Server 2025 pré-installé, Anti-DDoS 17+ Tbps INCLUS. 100 à 300+ joueurs. Activation immédiate.'
        },
        hero: {
          title: 'VPS Windows & Anti-DDoS',
          subtitle: 'CPU 5.20GHz, stockage NVMe Gen4, Windows Server pré-installé et protection L3/L4/L7 propriétaire pour garder votre communauté en ligne.',
          rating: {
            value: '4.9/5',
            caption: '87 avis vérifiés · 450+ serveurs protégés'
          },
          priceFrom: {
            value: 'Dès 64,99€',
            suffix: '/mois — sans engagement'
          },
          ctaOrderNow: 'Commander maintenant',
          ctaSeeOffers: 'Voir les offres'
        },
        plans: {
          pretitle: 'VPS Windows + Protection',
          title: 'Nos offres VPS Windows',
          subtitle: 'Choisissez la configuration Windows adaptée à la taille de votre communauté.',
          recommended: 'RECOMMANDÉ',
          select: 'Choisir cette offre',
          includes: 'Inclus dans toutes les offres :',
          globalFeatures: [
            'Windows Server 2025 pré-installé et activé',
            'Protection Anti-DDoS L3/L4/L7',
            'Bande passante 10 Gbit/s + monitoring en temps réel',
            'Dashboard & API FIVEMSHIELD'
          ],
          ddosUpgrade: {
            title: 'Protection DDoS Ultra',
            price: '30€',
            description: 'Ajoutez une protection DDoS Ultra à votre VPS Windows pour une sécurité renforcée contre les attaques les plus sophistiquées.',
            features: [
              'Filtrage comportemental avancé',
              'Absorption des attaques les plus sophistiquées',
              'Activation immédiate'
            ]
          },
          ironbyte: {
            badge: 'Essentiel',
            description: 'Idéal pour les communautés Windows jusqu\'à 100+ joueurs.',
            features: [
              '6 vCores 4.20GHz',
              '16 Go RAM DDR5 ECC',
              '120 Go NVMe Gen4',
              'Protection DDoS Stage 1',
              'Windows Server 2025 inclus',
              'Support standard 7j/7'
            ]
          },
          steelforge: {
            badge: 'Haute affluence',
            description: 'Taillé pour les serveurs Windows jusqu\'à 180+ joueurs.',
            features: [
              '8 vCores 4.20GHz',
              '32 Go RAM DDR5 ECC',
              '160 Go NVMe Gen4',
              'Protection DDoS Stage 2',
              'Windows Server 2025 inclus',
              'Support prioritaire 24/7'
            ]
          },
          fireguard: {
            badge: 'Enterprise',
            description: 'Pensé pour les réseaux multi-serveurs et les communautés de 300+ joueurs.',
            features: [
              '12 vCores 4.20GHz',
              '48 Go RAM DDR5 ECC',
              '300 Go NVMe Gen4',
              'Protection DDoS Stage 2',
              'Windows Server 2025 inclus',
              'Support TAM 24/7 & SLA contractuel'
            ]
          },
          contact: 'Besoin d\'une configuration sur-mesure ou multi-VPS ?',
          contactCta: 'Contacter le service commercial'
        },
        faq: {
          title: 'Questions fréquentes sur nos VPS Windows',
          subtitle: 'Tout ce qu\'il faut savoir avant de migrer chez FIVEMSHIELD.',
          items: [
            {
              question: 'Quelle version de Windows est installée ?',
              answer: 'Tous nos VPS Windows sont livrés avec Windows Server 2025 Datacenter, pré-installé et activé. Vous avez un accès administrateur complet dès la livraison.'
            },
            {
              question: 'La licence Windows est-elle incluse ?',
              answer: 'Oui, la licence Windows Server est incluse dans le prix de l\'offre. Aucun frais supplémentaire pour le système d\'exploitation.'
            },
            {
              question: 'Puis-je installer mes propres logiciels ?',
              answer: 'Absolument. Vous avez un accès administrateur complet via RDP. Installez txAdmin, vos scripts FiveM, SQL Server, ou tout autre logiciel nécessaire.'
            },
            {
              question: 'La protection Anti-DDoS fonctionne-t-elle avec Windows ?',
              answer: 'Oui, notre protection Anti-DDoS est identique sur Linux et Windows. Elle filtre les attaques L3/L4/L7 avant qu\'elles n\'atteignent votre serveur.'
            }
          ]
        },
        cta: {
          title: 'Lancez votre VPS Windows en moins de 10 minutes',
          subtitle: 'Commandez en ligne ou planifiez un appel avec un ingénieur solution.',
          primary: 'Créer mon VPS Windows',
          secondary: 'Planifier un appel'
        }
      },
      footerV2: {
        newsletterCta: 'Rejoignez notre communauté Discord',
        headline1: 'Hébergez.',
        headline2: 'Protégez.',
        headline3: 'Dominez.',
        ctaCard: {
          title: 'Activez votre protection',
          description: 'Configuration en moins de 10 minutes. Anti-DDoS inclus, support 24/7.',
          badge: 'SLA 99,99 %'
        },
        watermark: 'FIVEMSHIELD'
      },
      panel: {
        breadcrumb: 'Panel FiveM',
        relaunch: {
          kicker: 'Game Panel',
          title: "Votre serveur FiveM en ligne en moins d'une minute",
          subtitle: 'Pensé pour les petites communautés. Protection DDoS incluse, aucune ligne de commande.',
          facts: [
            { value: '< 1 min', label: 'Mise en ligne' },
            { value: 'Inclus', label: 'Anti-DDoS' },
            { value: 'dès 3,99€', label: 'Par mois' }
          ],
          ctaPrimary: 'Choisir une offre',
          ctaSecondary: 'Comment ça marche'
        },
        steps: {
          kicker: 'Mise en place',
          title: 'Trois étapes, une minute',
          items: [
            { time: '0:00', title: 'Choisissez votre offre', desc: 'Paiement, puis accès immédiat au panel.' },
            { time: '0:20', title: 'Sélectionnez un template', desc: 'RP, drift ou free access, déjà configuré.' },
            { time: '0:45', title: 'Votre serveur est en ligne', desc: 'Protégé, surveillé, prêt pour vos joueurs.' }
          ]
        },
        migration: {
          kicker: 'Migration',
          title: "Changez d'hébergeur sans tout reconfigurer",
          body: "Vous venez d'un autre hébergeur ? Connectez-vous à votre ancien serveur et le panel importe vos resources et votre server.cfg automatiquement, en quelques clics.",
          points: [
            "Connexion SFTP ou FTP, le temps de l'import",
            'Vous choisissez ce qui est transféré',
            'Resources et server.cfg récupérés automatiquement',
          ],
        },
        gallery: {
          kicker: 'Aperçu',
          title: 'Le panel, en vrai'
        },
        included: {
          title: 'Compris dans chaque offre',
          items: ['Protection Anti-DDoS', 'Sauvegardes automatiques', 'Monitoring CPU / RAM', 'Support 24/7']
        },
        finalCta: {
          title: 'Prêt à lancer votre serveur ?',
          subtitle: "Sans engagement. Changez d'offre quand vous voulez.",
          button: 'Démarrer maintenant'
        },
        seo: {
          title: 'Hébergeur FiveM | Game Panel dès 3,99€, Anti-DDoS Inclus | FIVEMSHIELD',
          description:
            "FIVEMSHIELD, hébergeur FiveM spécialisé : Game Panel pensé pour les petites communautés, protection Anti-DDoS incluse, mise en ligne en moins d'une minute, sans ligne de commande. Offres dès 3,99€/mois.",
          keywords:
            'hebergeur fivem, meilleur hebergeur fivem, game panel fivem, panel fivem pas cher, hebergement fivem petit serveur, panel fivem anti ddos, gestion serveur fivem 1 clic, fxserver panel, panel fivem debutant'
        },
        hero: {
          kicker: 'Panel FiveM tout‑en‑un',
          title: 'Administrez votre serveur FiveM sans scripts ni CLI',
          subtitle:
            'Déployez, automatisez et surveillez vos instances FiveM depuis un cockpit pensé pour les équipes RP modernes.',
          bullets: [
            'Déploiement en 1-Clic',
            'Gestion ressources, backups et txAdmin centralisée',
            'Monitoring CPU/RAM + alertes Discord intégrés'
          ],
          stats: [
            { value: '1 min', label: 'Installation moyenne' },
            { value: '12+ automations', label: 'Restart & monitoring' },
            { value: '24/7', label: 'Support prioritaire' }
          ],
          ctaPrimary: 'Essayer gratuitement',
          ctaSecondary: 'Voir les fonctionnalités'
        },
        features: {
          kicker: 'Fonctionnalités',
          title: 'Un cockpit pensé pour FiveM',
          subtitle: 'Chaque module est optimisé pour les besoins des équipes RP.',
          items: [
            {
              title: 'Déploiement 1‑clic',
              description: 'Installez un serveur RP, drift ou free access en 60 secondes avec scripts préconfigurés.'
            },
            {
              title: 'Automations & snapshots',
              description: 'Redémarrages intelligents, sauvegardes programmées et rollbacks instantanés.'
            },
            {
              title: 'Monitoring intégré',
              description: 'Metrics CPU/RAM, logs txAdmin et alertes Discord sans config supplémentaire.'
            },
            {
              title: 'Support prioritaire',
              description: 'Escalade directe vers nos ingénieurs FiveM pour vos évènements critiques.'
            }
          ]
        },
        plans: {
          specs: { cpu: 'threads CPU Ryzen 7950X', ram: 'mémoire DDR5', storage: 'stockage NVMe', cta: 'Commander', ddos: 'Protection DDoS FIVEMSHIELD incluse' },
          selector: 'Faites glisser pour ajuster la puissance',
          kicker: 'Mensuel',
          title: 'Choisissez votre cadence',
          subtitle: 'Sans engagement. Upgrade instantané.',
          items: [
            { name: 'Scout', price: '3,99€', threads: '1', ram: '1', storage: '10' },
            { name: 'Patrol', price: '6,99€', threads: '2', ram: '2', storage: '20' },
            { name: 'Guard', price: '12,99€', threads: '2', ram: '4', storage: '50' },
            { name: 'Sentry', price: '27,50€', threads: '3', ram: '8', storage: '100', badge: 'Le plus choisi' },
            { name: 'Ranger', price: '39,99€', threads: '4', ram: '12', storage: '150' },
            { name: 'Vanguard', price: '54,99€', threads: '6', ram: '16', storage: '200' },
            { name: 'Bastion', price: '64,99€', threads: '6', ram: '20', storage: '200' },
            { name: 'Citadel', price: '79,99€', threads: '8', ram: '25', storage: '300' },
            { name: 'Fortress', price: '110,00€', threads: '12', ram: '32', storage: '300' },
          ]
        },
        lifetime: {
          kicker: 'Licences',
          title: 'Payez une fois, servez longtemps',
          subtitle: 'Idéal pour les streamers et studios cherchant une solution pérenne.',
          badge: 'Licence perpétuelle',
          items: [
            {
              name: 'Lifetime Basic',
              description: 'Licence perpétuelle pour un serveur FiveM unique.',
              price: '49,99€',
              bullets: [
                '4 vCore AMD @ 5.20GHz',
                '4 Go RAM • 40 Go NVMe',
                'Support prioritaire'
              ],
              cta: 'Commander'
            },
            {
              name: 'Lifetime Plus',
              description: 'Pensé pour les serveurs publics ou whitelist.',
              price: '99,99€',
              bullets: [
                'Protection Anti-DDoS : Anti-DDoS Ultra',
                '6 vCore AMD @ 5.20GHz',
                '8 Go RAM • 80 Go NVMe',
                'Support prioritaire'
              ],
              cta: 'Commander'
            },
            {
              name: 'Lifetime Ultra',
              description: 'Pour les studios et réseaux multi-serveurs.',
              price: '149,99€',
              bullets: [
                'Protection Anti-DDoS : Anti-DDoS Ultra+',
                '8 vCore AMD @ 5.20GHz',
                '16 Go RAM • 160 Go NVMe',
                'Support prioritaire'
              ],
              cta: 'Commander'
            }
          ]
        },
        faq: {
          title: 'Questions fréquentes',
          subtitle: 'Tout ce qu’il faut savoir avant de migrer.',
          items: [
            {
              question: 'Le panel nécessite‑t‑il txAdmin ?',
              answer:
                'Oui, nous nous appuyons sur txAdmin pour la couche runtime, mais nous automatisons les tâches répétitives et exposons une interface graphique simplifiée.'
            },
            {
              question: 'Puis‑je importer mon serveur existant ?',
              answer:
                'Absolument. Notre assistant accepte vos ressources, bases de données et scripts. Un ingénieur peut vous assister gratuitement pendant la migration.'
            },
            {
              question: 'Comment gérez‑vous les sauvegardes ?',
              answer:
                'Snapshots incrémentaux, export S3/Backblaze et possibilité d’automatiser un push vers votre propre bucket. Restaurations en un clic.'
            },
            {
              question: 'Le panel est‑il accessible sur mobile ?',
              answer:
                'Oui, l’interface est responsive et nous proposons un mode PWA pour recevoir les alertes critiques et déclencher un redémarrage même en déplacement.'
            }
          ],
          footer: 'FIVEMSHIELD • Panel + Anti‑DDoS + Reverse Proxy'
        }
      },
      reverse: {
        breadcrumb: 'Reverse Proxy',
        seo: {
          title: 'Reverse Proxy FiveM | Protection Anti-DDoS Ultimate | FIVEMSHIELD',
          description:
            'Protégez votre serveur FiveM avec notre Reverse Proxy : masquage IP, mitigation DDoS L3/L4/L7, 0 latence ajoutée. Configuration en 10 min. 17+ Tbps de capacité.'
        },
        hero: {
          kicker: 'Reverse Proxy Anti-DDoS',
          title: 'Gardez votre hébergeur.',
          subtitle:
            'On protège votre serveur FiveM avec 2 lignes dans le server.cfg. Votre IP disparaît, les attaques DDoS sont bloquées — sans migrer, sans rien changer chez votre hébergeur actuel.',
          points: [
            'Installation guidée en moins de 10 minutes',
            'Votre IP réelle reste 100% invisible',
            'Protection active 24/7 avec monitoring temps réel'
          ],
          stats: [
            { value: '17+ Tbps', label: 'Capacité d\'absorption mondiale' },
            { value: '0 ms', label: 'Latence ajoutée' },
            { value: '99.99%', label: 'Disponibilité garantie' }
          ],
          ctaPrimary: 'Configurer ma protection',
          ctaSecondary: 'Parler à un expert',
          cardTitle: 'Pourquoi choisir notre Reverse Proxy ?',
          cardSubtitle: 'Protection spécialisée FiveM avec filtrage intelligent des endpoints /info.json, /players.json et analyse comportementale du trafic.',
          cardNote: 'Aucune modification de votre hébergement • Activation instantanée • Support dédié 24/7',
          compatibility: {
            label: 'Fonctionne avec votre hébergeur actuel',
            hosts: ['OVHcloud', 'Hetzner', 'Contabo', 'Kimsufi', 'Et bien d\'autres']
          }
        },
        howItWorks: {
          kicker: 'Comment ça marche',
          title: '3 étapes, aucune migration',
          subtitle: 'Pas besoin de changer d\'hébergeur ni de toucher à votre installation existante.',
          steps: [
            {
              title: 'Vous gardez votre hébergeur',
              description: 'Votre serveur reste exactement là où il est aujourd\'hui.'
            },
            {
              title: 'Vous ajoutez 2 lignes à votre server.cfg',
              description: 'On vous envoie la configuration exacte à copier-coller. Ça prend moins de 10 minutes.'
            },
            {
              title: 'Votre IP disparaît, la protection s\'active',
              description: 'Les joueurs passent par notre reverse proxy. Votre IP réelle n\'est plus jamais visible, ni attaquable.'
            }
          ]
        },
        features: {
          kicker: 'Protection Multi-Couches',
          title: 'La sécurité totale pour votre serveur FiveM',
          subtitle: 'Chaque couche de protection est optimisée pour les besoins spécifiques des serveurs FiveM.',
          items: [
            {
              title: 'Protection DDoS L3/L4/L7 Complète',
              description: 'Mitigation automatique des attaques volumétriques, protocoles et applicatives. Filtrage intelligent des requêtes malveillantes ciblant vos endpoints FiveM.'
            },
            {
              title: 'Masquage IP Absolu',
              description: 'Votre IP réelle reste totalement invisible. Seules nos adresses Anycast distribuées sont exposées, rendant votre serveur introuvable pour les attaquants.'
            },
            {
              title: 'Performance & Stabilité Garanties',
              description: 'Routage Anycast intelligent, peering Tier-1 et optimisation TCP/UDP. Vos joueurs bénéficient d\'une latence ultra-faible et d\'une connexion stable.'
            },
            {
              title: 'Monitoring & Alertes en Temps Réel',
              description: 'Dashboard complet, notifications Discord/Webhook instantanées et rapports détaillés. Visualisez chaque attaque bloquée en temps réel.'
            }
          ]
        },
        steps: {
          kicker: 'Mise en place',
          title: 'Protection active en moins de 10 minutes',
          subtitle: 'Notre équipe technique gère toute la configuration pour vous.',
          items: [
            {
              title: '1. Audit gratuit de votre infrastructure',
              description: 'Analyse de vos ports, configuration FiveM, scripts critiques et besoins spécifiques. Nous préparons une configuration sur-mesure pour votre serveur.'
            },
            {
              title: '2. Configuration DNS & activation',
              description: 'Mise en place des enregistrements DNS ou tunnel GRE selon votre préférence. Tests de charge complets et validation des performances avant mise en production.'
            },
            {
              title: '3. Protection active & monitoring 24/7',
              description: 'Votre serveur est protégé ! Accès au dashboard de monitoring, alertes configurables et support technique prioritaire disponible à tout moment.'
            }
          ]
        },
        stack: {
          title: 'Infrastructure de protection FIVEMSHIELD',
          subtitle: 'Technologie de pointe incluse dans chaque offre.',
          cards: [
            {
              title: 'Scrubbing Centers 17+ Tbps',
              description: 'Réseau distribué sur 8 points de présence capables d\'absorber les plus grosses attaques DDoS volumétriques et applicatives.'
            },
            {
              title: 'Routage BGP Anycast',
              description: 'Annonce multi-PoP avec basculement automatique. Vos joueurs se connectent toujours au point le plus proche pour une latence minimale.'
            },
            {
              title: 'SOC 24/7 & Escalade Intelligente',
              description: 'Centre d\'opérations de sécurité actif en permanence. Règles personnalisées, rapports post-incident et assistance technique prioritaire.'
            }
          ]
        },
        calculator: {
          kicker: 'Tarification',
          title: 'Combien coûte la protection pour votre serveur ?',
          subtitle: 'Prix transparent basé sur votre capacité de joueurs. Aucun frais caché.',
          capacity: 'Capacité serveur',
          players: 'joueurs',
          priceLabel: 'Prix mensuel',
          perMonth: '/mois',
          hint: 'Besoin d\'une protection pour +800 joueurs ? Contactez notre équipe commerciale pour un devis personnalisé.',
          cta: 'Commencer maintenant',
          sliderMin: '50 joueurs',
          sliderMax: '800 joueurs',
          includes: [
            'Protection L3/L4/L7 complète',
            'Masquage IP total',
            'Support 24/7 inclus',
            'Configuration en 10 min'
          ]
        },
        serverCfg: {
          badge: 'Intégration universelle',
          title: 'Fonctionne avec n\'importe quel hébergeur',
          subtitle: 'Pas de migration, pas de changement d\'hébergeur. Deux lignes dans votre server.cfg et c\'est tout — notre équipe s\'occupe du reste.',
          note: 'Notre équipe vous envoie les lignes exactes à copier-coller. Configuration en moins de 10 minutes.',
          compatible: 'Compatible avec tous les hébergeurs',
          recommended: 'Partenaire recommandé',
          recommendedDesc: 'Nous privilégions OVHcloud pour ses infrastructures européennes, sa stabilité réseau et son peering optimisé — un socle idéal pour exploiter pleinement notre reverse proxy.',
          commentLine: '# Ajoutez ces 2 lignes dans votre server.cfg',
          lastLine: '# C\'est tout — notre équipe gère le reste'
        },
        customDomain: {
          badge: 'Nouveauté',
          title: 'Votre propre sous-domaine de connexion',
          subtitle: 'Fini les adresses impersonnelles. Vos joueurs se connectent via votre propre sous-domaine — un lien simple, mémorable et 100% à votre image.',
          beforeLabel: 'Avant',
          beforeTag: 'Générique',
          beforeDesc: 'Une adresse partagée, difficile à retenir et qui ne reflète pas votre marque.',
          afterLabel: 'Avec FIVEMSHIELD',
          afterTag: 'Protégé',
          afterDesc: 'Votre sous-domaine personnalisé, propre à votre serveur, mémorable et professionnel.'
        },
        keyPoints: [
          { title: 'Protection L3/L4/L7', desc: 'Mitigation automatique des attaques volumétriques et applicatives ciblant vos endpoints FiveM.' },
          { title: 'Masquage IP total', desc: 'Votre IP réelle reste invisible. Seules nos adresses Anycast sont exposées aux attaquants.' },
          { title: '0 ms de latence ajoutée', desc: 'Routage Anycast optimisé. Vos joueurs ne voient aucune différence, sauf une meilleure stabilité.' }
        ],
        finalCta: {
          title: 'Prêt à protéger votre serveur FiveM ?',
          subtitle: 'Rejoignez les centaines de serveurs qui font confiance à FIVEMSHIELD pour leur sécurité.',
          start: 'Activer ma protection',
          talk: 'Parler à un expert'
        },
        faq: {
          title: 'Questions fréquentes',
          subtitle: 'Tout ce que vous devez savoir sur notre Reverse Proxy.',
          items: [
            {
              question: 'Est-ce que cela va ralentir mon serveur ?',
              answer:
                'Non, absolument pas ! Notre infrastructure Anycast ajoute 0ms de latence. En réalité, la plupart de nos clients constatent même une amélioration de la stabilité grâce à notre routage optimisé et notre peering Tier-1.'
            },
            {
              question: 'Dois-je changer d\'hébergeur ?',
              answer:
                'Pas du tout. Notre Reverse Proxy fonctionne avec n\'importe quel hébergeur. Vous gardez votre serveur actuel, nous ajoutons simplement une couche de protection devant. Aucune migration nécessaire.'
            },
            {
              question: 'Combien de temps prend la mise en place ?',
              answer:
                'La configuration complète prend généralement 10 à 30 minutes. Notre équipe technique vous accompagne à chaque étape : audit, configuration DNS/GRE, tests et activation. Vous êtes protégé le jour même.'
            },
            {
              question: 'Que se passe-t-il pendant une attaque DDoS ?',
              answer:
                'Notre système détecte et filtre automatiquement le trafic malveillant en temps réel. Les attaques sont absorbées par nos scrubbing centers sans impacter vos joueurs. Vous recevez des alertes et pouvez suivre l\'attaque en direct sur votre dashboard.'
            },
            {
              question: 'Quelle est la taille maximale d\'attaque que vous pouvez bloquer ?',
              answer:
                'Notre infrastructure peut absorber des attaques allant jusqu\'à 17+ Tbps. Nous avons déjà protégé nos clients contre des attaques dépassant 8 Tbps sans aucune interruption de service.'
            },
            {
              question: 'Puis-je utiliser mon propre sous-domaine pour la connexion ?',
              answer:
                'Oui, c\'est inclus ! Vos joueurs peuvent se connecter via votre propre sous-domaine (ex: play.votre-serveur.fr) au lieu d\'une adresse générique. Notre équipe configure le DNS, le SSL et l\'enregistrement SRV FiveM en moins de 10 minutes. Vous gardez le contrôle total de votre domaine et votre IP réelle reste totalement masquée.'
            }
          ]
        }
      },

      home: {
        newVpsWindows: {
          badge: 'Nouveau',
          text: 'Découvrez nos offres VPS Windows Server 2025',
          cta: 'Découvrir maintenant'
        },
        underAttack: {
          badge: 'Sous Attaque ?',
          title: 'Contactez-nous directement',
          description: 'On s\'occupe de tout — migration & protection complète de votre serveur FiveM.',
          cta: 'Nous contacter maintenant'
        },
        hero: {
          cta: {
            learnMore: 'En savoir plus'
          }
        },
        protection: {
          title: 'Mitigation XDP Propriétaire',
          paragraph:
            "Nous avons développé notre propre stack de mitigation basée sur XDP (eXpress Data Path) et eBPF, opérant directement au niveau du driver NIC pour un filtrage kernel-bypass à plus de 100 Mpps. Notre technologie neutralise les attaques L3/L4/L7 avant même qu'elles n'atteignent l'espace utilisateur.",
          bullets: {
            heuristic: "XDP/eBPF Filtering — Traitement des paquets en kernel-space avec latence sub-microseconde et inspection stateful des flux TCP/UDP FiveM",
            anycast: "Scrubbing distribué 17+ Tbps — Infrastructure BGP Anycast multi-PoP avec GRE/IPIP tunneling et ECMP load-balancing",
            tls: "Deep Packet Inspection L7 — Analyse protocolaire des endpoints FiveM (/info.json, /players.json) avec rate-limiting adaptatif et fingerprinting JA3"
          }
        },
        dashboard: {
          title: 'Dashboard Tout-en-un',
          paragraph:
            "Les services de FIVEMSHIELD ne nécessitent aucune interaction manuelle. Cependant, pour ceux qui trouvent un tableau de bord utile, nous avons développé un portail qui inclut la bande passante transmise/bloquée, les incidents d'attaque, et les ports filtrés. Vous pouvez également suivre la bande passante pour une IP spécifique.",
          bullets: {
            realtime: "Suivi en temps réel des tentatives d'attaques",
            bandwidth: 'Visualisation graphique de la bande passante',
            history: 'Historique détaillé des incidents'
          }
        },
        diagram: {
          title: 'Comment fonctionne notre protection',
          paragraph:
            'Notre système intelligent filtre les attaques tout en optimisant le trafic légitime vers votre serveur FiveM.'
        },
        solutions: {
          title: 'Nos Solutions',
          paragraph:
            "Découvrez nos offres spécialement conçues pour répondre à tous vos besoins d'hébergement et de protection FiveM."
        },
        guarantee: 'Satisfait ou remboursé sous 48h · Sans engagement · Support réactif',
        priceFrom: 'dès',
        pricePeriod: '/mois',
        infra: {
          stack: {
            kicker: 'Notre technologie',
            title: 'Une mitigation que nous écrivons nous-mêmes',
            body: "Pas de boîtier revendu, pas de filtrage sous-traité. Notre pile DPDK/XDP traite les paquets au plus près de la carte réseau, avant même que le système ne les voie. C'est ce qui nous permet de l'ajuster aux protocoles FiveM plutôt que d'appliquer des règles génériques.",
            points: ['Filtrage en espace noyau', 'Règles taillées pour FiveM', 'Développé en interne']
          },
          record: {
            kicker: 'Sur le terrain',
            title: 'Aucun bypass sur FiveM depuis plus d\'un an',
            body: "Les méthodes d'attaque visant FiveM changent vite. Les nôtres aussi : chaque tentative observée sur le réseau vient nourrir nos règles. Résultat, plus de douze mois sans qu'un bypass ne passe.",
            points: ['12+ mois sans bypass', 'Règles mises à jour en continu', 'Surveillance 24/7'],
          },
          monitoring: {
            kicker: 'Supervision',
            title: 'Chaque paquet, suivi en temps réel',
            body: "Nos ingénieurs voient le trafic paquet par paquet, à la seconde près. Un pic d'attaque est détecté et filtré avant qu'il n'ait une chance d'affecter votre serveur.",
            points: ['Inspection paquet par paquet', 'Alertes en quelques secondes', 'Supervision 24/7 par nos ingénieurs'],
          }
        },
        network: {
          kicker: 'Réseau mondial',
          title: 'Un réseau au plus près de vos joueurs',
          paragraph: "Vos joueurs se connectent au point de présence le plus proche. Le trafic est filtré avant d'atteindre votre serveur, dont l'IP reste masquée.",
          hint: 'Survolez un point',
          regions: { europe: 'Europe', northAmerica: 'Amérique du Nord', asia: 'Asie' },
          features: {
            filtering: { title: 'Filtrage L3 / L4 / L7', desc: 'Mitigation XDP, spécialisée FiveM.' },
            anycast: { title: 'Routage Anycast', desc: 'Chaque joueur rejoint le PoP le plus proche.' },
            capacity: { title: '17+ Tbps de capacité', desc: 'Les attaques massives sont absorbées.' }
          },
          pops: {
            gravelines: { city: 'Gravelines', country: 'France' },
            frankfurt: { city: 'Francfort', country: 'Allemagne' },
            london: { city: 'Londres', country: 'Royaume-Uni' },
            warsaw: { city: 'Varsovie', country: 'Pologne' },
            madrid: { city: 'Madrid', country: 'Espagne' },
            barcelona: { city: 'Barcelone', country: 'Espagne' },
            montreal: { city: 'Montréal', country: 'Canada' },
            toronto: { city: 'Toronto', country: 'Canada' },
            mumbai: { city: 'Mumbai', country: 'Inde' },
            singapore: { city: 'Singapour', country: 'Singapour' }
          }
        },
        finalCta: {
          title: 'Prêt à protéger votre serveur ?',
          subtitle: 'Rejoignez les centaines de serveurs FiveM qui nous font confiance.',
          button: 'Commencer maintenant'
        },
        vpsCard: {
          title: 'VPS Haute Performance',
          description:
            "Serveurs dédiés à haute fréquence avec CPU 5.20GHz, optimisés pour FiveM avec protection Anti-DDoS intégrée.",
          bullets: {
            cpu: 'CPU haute fréquence (5.20GHz)',
            storage: 'Stockage NVMe ultra-rapide',
            ddos: 'Protection DDoS incluse'
          },
          cta: 'Découvrir nos offres VPS'
        },
        vpsWindowsCard: {
          title: 'VPS Windows',
          description:
            'Serveurs VPS Windows Server 2025 avec protection Anti-DDoS intégrée, idéal pour FiveM.',
          bullets: {
            windows: 'Windows Server 2025 inclus',
            storage: 'Stockage NVMe ultra-rapide',
            ddos: 'Protection DDoS incluse'
          },
          cta: 'Découvrir VPS Windows'
        },
        panelCard: {
          title: 'Game Panel',
          description:
            "Un serveur FiveM clé en main, en ligne en moins d'une minute. Protection DDoS incluse, aucune ligne de commande.",
          cta: 'Découvrir le Game Panel'
        },
        cdnCard: {
          title: 'CDN & Caching',
          description:
            'Accélérez la connexion de vos joueurs avec notre CDN haute performance. Temps de chargement divisé par 10.',
          cta: 'Découvrir le CDN'
        },
        proxyCard: {
          title: 'Reverse Proxy',
          description:
            'Protection Anti-DDoS avancée pour votre serveur FiveM existant. Soyez attaqué sans compromettre la stabilité.',
          bullets: {
            l3l7: 'Protection L3/L4/L7',
            latency: 'Latence minimale',
            ipMask: 'Masquage complet de votre IP'
          },
          cta: 'Explorer la protection Proxy'
        },
        support: {
          title: 'Support Dédié',
          paragraph:
            "Une équipe d'experts disponible pour vous aider à résoudre tous vos problèmes et répondre à vos questions."
        },
        standardSupport: {
          title: 'Support Standard',
          paragraph:
            'Notre équipe de support standard est disponible pour répondre à vos questions et résoudre vos problèmes.',
          bullets: {
            hours: 'Disponible de 11:00 à 22:00 (UTC)',
            channels: 'Assistance technique par E-mail et Ticket',
            response: 'Temps de réponse moyen: 1 à 2 heures'
          },
          note: 'Inclus avec toutes nos offres standard'
        },
        premiumSupport: {
          title: 'Support Premium',
          paragraph: 'Une assistance prioritaire disponible 24/7 pour un support ultra-rapide et personnalisé.',
          bullets: {
            availability: 'Disponible 24/7, 365 jours par an',
            channels: 'Assistance prioritaire par ticket et chat',
            response: 'Temps de réponse moyen: 5 minutes'
          },
          note: 'Disponible en option'
        },
        discord: {
          title: 'Rejoignez notre communauté Discord',
          paragraph:
            'Accédez à notre support technique, échangez avec notre communauté et restez informé des dernières actualités sur notre serveur Discord officiel.',
          cta: 'Rejoindre Discord'
        },
        faq: {
          title: 'Questions Fréquentes sur nos Services FiveM',
          paragraph:
            "Découvrez les réponses aux questions fréquemment posées sur notre hébergement et protection FiveM",
          q1: {
            title:
              "Qu'est-ce que FIVEMSHIELD propose comme services d'hébergement pour FiveM?",
            answer:
              "FIVEMSHIELD est un fournisseur d'hébergement spécialisé pour les serveurs FiveM offrant des services VPS hautes performances avec des processeurs à 5.20GHz, un stockage NVMe rapide et une protection Anti-DDoS intégrée. Nous proposons également des services de reverse proxy et de panel de gestion pour simplifier l'administration de votre serveur FiveM."
          },
          q2: {
            title: 'Comment fonctionne la protection Anti-DDoS pour les serveurs FiveM?',
            answer:
              "Notre protection Anti-DDoS pour FiveM utilise une approche multicouche qui filtre intelligemment le trafic malveillant tout en permettant aux joueurs légitimes d'accéder à votre serveur sans latence. Notre système peut absorber jusqu'à 4.5 Tbps d'attaques et offre une protection contre les menaces L3, L4 et L7, spécifiquement adaptée aux besoins des serveurs FiveM."
          },
          q3: {
            title:
              "Pourquoi choisir un hébergeur spécialisé FiveM plutôt qu'un hébergeur standard?",
            answer:
              "Les serveurs FiveM ont des exigences spécifiques que les hébergeurs standards ne peuvent pas toujours satisfaire. FIVEMSHIELD propose des serveurs optimisés avec des CPU à haute fréquence (crucial pour FiveM), une architecture réseau optimisée pour réduire la latence et une protection Anti-DDoS spécifiquement configurée pour les modèles d'attaque ciblant les serveurs de jeux. Nos configurations sont entièrement optimisées pour maximiser les performances et la stabilité de votre serveur FiveM."
          },
          q4: {
            title: 'Quelle offre VPS choisir pour mon serveur FiveM?',
            answer:
              "Le choix de votre offre VPS dépend principalement du nombre de joueurs que vous prévoyez d'accueillir. Pour les communautés en croissance (30 à 80 joueurs), notre offre StealthEdge est idéale. Pour les serveurs à forte affluence (80-150 joueurs), nous recommandons l'offre StormGuard avec ses 8 vCore et 32GB de RAM. Les grands réseaux multi-serveurs (150+ joueurs) bénéficieront pleinement de notre offre TitanShield. Toutes nos offres incluent une protection Anti-DDoS adaptée à la taille de votre serveur."
          }
        },
        testimonials: {
          badge: 'Avis Clients',
          title: 'Ils nous font confiance',
          subtitle: 'Découvrez les retours de nos clients qui protègent leurs serveurs FiveM avec FIVEMSHIELD.',
          founderPrefix: 'Fondateur :',
          roleLabel: 'Fondateur',
          players: 'joueurs',
          heroTitle: 'Avis Authentiques',
          heroFrom: 'De nos',
          heroBracket: 'Clients',
          allReviews: 'Consultez tous nos avis',
          items: {
            server1: 'Service : ⭐️⭐️⭐️⭐️⭐️/5\nRapidité : ⭐️⭐️⭐️⭐️⭐️/5\nPatience : ⭐️⭐️⭐️⭐️⭐️/5\nCompréhension : ⭐️⭐️⭐️⭐️⭐️/5\nProfessionnalisme : ⭐️⭐️⭐️⭐️⭐️/5\n\nToujours présent quand il faut !',
            server2: 'Nous possédons un reverse proxy depuis quelques mois et franchement, leur support est juste incroyable ! Rapide, efficace, sympa !',
            server3: 'J’ai récemment souscrit à deux offres chez FIVEMSHIELD : l’une pour l’hébergement du serveur et l’autre pour une protection anti-DDoS. Ce que j’ai particulièrement apprécié, c’est qu’ils sont français comme moi : pour les questions ou demandes d’aide, c’est beaucoup plus simple. L’équipe est à l’écoute et réactive. J’ai surtout échangé avec Lucas, très professionnel, et je ne doute pas que le reste de l’équipe soit tout aussi compréhensif et expérimenté. Cela fait bientôt un mois que nous utilisons leurs services et je n’ai absolument rien à leur reprocher : lorsqu’un problème survient, il est résolu en moins de cinq heures. J’ai volontairement pris du recul avant de donner mon avis pour juger sur le moyen/long terme, et je suis satisfait à 100 %. Si vous hésitez encore, n’hésitez plus. En tant que serveur n°1 en PvP, Rush PvP a besoin de stabilité, et FivemShield a su nous l’apporter. Merci encore à eux.',
            server4: 'Kyerooo #AlyaRP',
            server5: '',
            server6: 'Service : ⭐️⭐️⭐️⭐️⭐️/5\nRapidité : ⭐️⭐️⭐️⭐️⭐️/5\nPatience : ⭐️⭐️⭐️⭐️⭐️/5\nCompréhension : ⭐️⭐️⭐️⭐️⭐️/5\nProfessionnalisme : ⭐️⭐️⭐️⭐️⭐️/5',
            server7: 'Great service and really fast support. Setup was super easy and everything works smoothly.\nHighly recommended 👍\n\nService : ⭐️⭐️⭐️⭐️⭐️/5\nRapidité : ⭐️⭐️⭐️⭐️⭐️/5\nPatience : ⭐️⭐️⭐️⭐️⭐️/5\nCompréhension : ⭐️⭐️⭐️⭐️⭐️/5\nProfessionnalisme : ⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️/5',
            server8: 'Service : ⭐️⭐️⭐️⭐️⭐️/5\nSupport : ⭐️⭐️⭐️⭐️⭐️/5\n\nVery fast customer support ❤️'
          }
        }
      },
      cdn: {
        breadcrumb: 'CDN & Caching',
        seo: {
          title: 'CDN FiveM Gratuit* | Connexion joueurs 10x plus rapide',
          description: 'CDN FiveM : vos joueurs se connectent 10x plus vite. Config en 2 lignes server.cfg. Compatible tous hébergeurs. Réduisez les déco et le temps de chargement.'
        },
        hero: {
          kicker: 'CDN & Caching FiveM',
          title: 'Accélérez vos resources et la connexion de vos joueurs',
          subtitle:
            'Notre CDN ultra-rapide distribue vos resources FiveM à travers le monde et accélère la connexion de vos joueurs. Configuration simple en 2 lignes dans votre server.cfg.',
          points: [
            'Configuration ultra-simple : 2 lignes dans server.cfg',
            'Réduction drastique du temps de chargement des resources',
            'Connexion joueurs jusqu\'à 10x plus rapide',
            'Distribution mondiale via notre réseau CDN'
          ],
          stats: [
            { value: '10x', label: 'Connexion plus rapide' },
            { value: '< 2 min', label: 'Configuration' },
            { value: '24/7', label: 'Support technique' }
          ],
          ctaPrimary: 'Activer le CDN',
          ctaSecondary: 'Voir la documentation',
          cardTitle: 'Comment ça fonctionne ?',
          cardSubtitle: 'Notre CDN met en cache vos resources et les distribue depuis nos serveurs edge ultra-rapides.',
          cardNote: 'Ajoutez simplement 2 lignes dans votre server.cfg et profitez immédiatement d\'une connexion ultra-rapide pour vos joueurs.'
        },
        features: {
          kicker: 'Avantages',
          title: 'Pourquoi utiliser notre CDN ?',
          subtitle: 'Une solution pensée pour FiveM avec des performances maximales.',
          items: [
            {
              title: 'Configuration instantanée',
              description: 'Ajoutez 2 lignes dans votre server.cfg et c\'est tout. Aucune modification de vos resources nécessaire.'
            },
            {
              title: 'Connexion ultra-rapide',
              description: 'Vos joueurs se connectent jusqu\'à 10x plus rapidement grâce à notre réseau de distribution mondial.'
            },
            {
              title: 'Resources accélérées',
              description: 'Téléchargement instantané des resources depuis nos serveurs edge proches de vos joueurs.'
            },
            {
              title: 'Bande passante économisée',
              description: 'Réduisez la charge sur votre serveur en déléguant la distribution des resources à notre CDN.'
            }
          ]
        },
        howItWorks: {
          kicker: 'Simplicité',
          title: 'Configuration en 2 lignes',
          subtitle: 'Activez le CDN en moins de 2 minutes.',
          steps: [
            {
              title: 'Ajoutez 2 lignes dans server.cfg',
              description: 'Copiez les 2 lignes de configuration que nous vous fournissons et collez-les dans votre server.cfg.',
              code: 'fileserver_add ".*" "https://cdn-caching.fivemshield.net/files"\nset adhesive_cdnKey "randomKeyHere" "CLE SECRETE"'
            },
            {
              title: 'Redémarrez votre serveur',
              description: 'Un simple redémarrage suffit pour activer le CDN. Aucune autre configuration nécessaire.'
            },
            {
              title: 'Profitez des performances',
              description: 'Vos joueurs bénéficient immédiatement d\'une connexion ultra-rapide et d\'un chargement instantané des resources.'
            }
          ]
        },
        plans: {
          kicker: 'Tarification',
          title: 'Choisissez votre plan CDN',
          subtitle: 'Des offres adaptées à la taille de votre communauté.',
          recommended: 'RECOMMANDÉ',
          select: 'Choisir cette offre',
          starter: {
            badge: 'Starter',
            price: '4,99€',
            description: 'Pour les petites communautés qui démarrent. Idéal jusqu\'à ~48 joueurs.',
            features: [
              'Bande passante : 2 TB/mois',
              'Cache dédié derrière Cloudflare',
              'Statistiques trafic temps réel',
              'Purge cache instantanée',
              'Support standard 7j/7'
            ]
          },
          pro: {
            badge: 'Professional',
            price: '14,99€',
            description: 'Le meilleur choix pour les serveurs en croissance. Idéal jusqu\'à ~128 joueurs.',
            features: [
              'Bande passante : 10 TB/mois',
              'Cache dédié derrière Cloudflare',
              'Statistiques trafic temps réel',
              'Purge cache instantanée',
              'Support prioritaire 24/7'
            ]
          },
          business: {
            badge: 'Business',
            price: '29,99€',
            description: 'Pour les gros serveurs à fort trafic. Idéal jusqu\'à ~256 joueurs.',
            features: [
              'Bande passante : 30 TB/mois',
              'Cache dédié derrière Cloudflare',
              'Statistiques trafic temps réel',
              'Purge cache instantanée',
              'Anycast',
              'Support prioritaire 24/7'
            ]
          },
          enterprise: {
            badge: 'Enterprise',
            price: '59,99€',
            description: 'Pour les grandes communautés et réseaux multi-serveurs.',
            features: [
              'Bande passante : 75 TB/mois',
              'Cache dédié derrière Cloudflare',
              'Statistiques trafic temps réel',
              'Purge cache instantanée',
              'Anycast',
              'Support dédié 24/7'
            ]
          },
          contact: 'Besoin d\'une solution sur-mesure ?',
          contactCta: 'Contacter notre équipe'
        },
        benefits: {
          title: 'Les avantages du CDN FIVEMSHIELD',
          subtitle: 'Une infrastructure pensée pour les performances maximales.',
          cards: [
            {
              title: 'Réseau mondial',
              description: 'Serveurs edge dans le monde entier pour une latence minimale partout.'
            },
            {
              title: 'Cache intelligent',
              description: 'Mise en cache automatique et optimisée de vos resources FiveM.'
            },
            {
              title: 'Monitoring temps réel',
              description: 'Dashboard complet pour suivre l\'utilisation et les performances de votre CDN.'
            }
          ]
        },
        faq: {
          title: 'Questions fréquentes',
          subtitle: 'Tout ce qu\'il faut savoir sur notre CDN.',
          items: [
            {
              question: 'Comment activer le CDN sur mon serveur ?',
              answer:
                'C\'est très simple ! Ajoutez les 2 lignes de configuration que nous vous fournissons dans votre server.cfg, redémarrez votre serveur et c\'est tout. Le CDN est immédiatement actif.'
            },
            {
              question: 'Dois-je modifier mes resources ?',
              answer:
                'Non, aucune modification de vos resources n\'est nécessaire. Notre CDN fonctionne de manière transparente avec votre configuration actuelle.'
            },
            {
              question: 'Quelle est la différence de vitesse ?',
              answer:
                'En moyenne, nos clients constatent une réduction de 70% du temps de connexion des joueurs et un téléchargement quasi-instantané des resources grâce à notre réseau de distribution mondial.'
            },
            {
              question: 'Puis-je utiliser le CDN avec mon hébergeur actuel ?',
              answer:
                'Oui, notre CDN fonctionne avec n\'importe quel hébergeur. Vous n\'avez pas besoin de migrer votre serveur pour profiter de notre CDN.'
            },
            {
              question: 'Que se passe-t-il si je dépasse ma bande passante ?',
              answer:
                'Nous vous prévenons avant d\'atteindre la limite. Vous pouvez alors upgrader vers un plan supérieur ou acheter de la bande passante supplémentaire à la demande.'
            }
          ]
        },
        finalCta: {
          title: 'Accélérez votre serveur dès aujourd\'hui',
          subtitle: 'Configuration en 2 minutes, résultats immédiats.',
          start: 'Activer le CDN',
          talk: 'Parler à un expert'
        }
      },
      privacy: {
        seo: {
          title: 'Politique de Confidentialité | FIVEMSHIELD',
          description: 'Politique de confidentialité de FIVEMSHIELD : collecte, traitement et protection de vos données personnelles conformément au RGPD.'
        },
        hero: {
          title: 'Politique de',
          titleHighlight: 'Confidentialité',
          subtitle: 'Vos données personnelles méritent d\'être protégées. Découvrez comment FIVEMSHIELD collecte, utilise et sécurise vos informations.'
        },
        lastUpdated: 'Dernière mise à jour : mai 2025',
        sections: {
          controller: {
            title: '1. Responsable du Traitement',
            body: 'xdpfilter (SIREN : 943 814 749, SIRET : 94381474900025), dont le siège social est situé au 78 AVENUE des Champs Élysées, 75008 Paris, France – Bureau 326, est responsable du traitement de vos données personnelles collectées via le site fivemshield.net.',
            contact: 'Pour toute question relative à vos données, contactez-nous à : contact@fivemshield.net'
          },
          collected: {
            title: '2. Données Collectées',
            intro: 'Nous collectons les données suivantes selon vos interactions avec nos services :',
            categories: [
              {
                label: 'Données d\'identification',
                items: ['Nom et prénom', 'Adresse e-mail', 'Pseudo / identifiant Discord']
              },
              {
                label: 'Données de facturation',
                items: ['Adresse de facturation', 'Historique des paiements', 'Numéro de transaction (traitement délégué à Stripe / PayPal)']
              },
              {
                label: 'Données techniques',
                items: ['Adresse IP', 'Logs de connexion et d\'accès', 'Informations sur les services souscrits (VPS, Reverse Proxy, CDN, Serveurs Dédiés)', 'Métriques d\'utilisation des ressources (bande passante, CPU, RAM)']
              },
              {
                label: 'Données de communication',
                items: ['Messages envoyés via le formulaire de contact ou les tickets support', 'Échanges sur Discord / WhatsApp dans le cadre du support']
              }
            ]
          },
          purposes: {
            title: '3. Finalités du Traitement',
            intro: 'Vos données sont traitées pour les finalités suivantes :',
            list: [
              'Création et gestion de votre espace client (manager.fivemshield.net)',
              'Fourniture et administration des services souscrits (VPS, Reverse Proxy, CDN, Serveurs Dédiés)',
              'Gestion de la facturation, des paiements et de la comptabilité',
              'Prévention des abus, fraudes et activités malveillantes sur nos infrastructures',
              'Réponse à vos demandes de support technique',
              'Envoi de notifications de service (renouvellement, incidents, maintenance)',
              'Amélioration de nos services et de l\'expérience utilisateur',
              'Respect de nos obligations légales'
            ]
          },
          legal: {
            title: '4. Bases Légales (RGPD)',
            intro: 'Les traitements reposent sur les bases légales suivantes au sens de l\'article 6 du RGPD :',
            list: [
              { basis: 'Exécution du contrat', detail: 'pour la gestion de votre compte, la livraison des services et la facturation.' },
              { basis: 'Intérêt légitime', detail: 'pour la prévention des abus, la sécurité des infrastructures et l\'amélioration des services.' },
              { basis: 'Obligation légale', detail: 'pour la conservation des données de facturation et les obligations comptables.' },
              { basis: 'Consentement', detail: 'pour l\'envoi de communications marketing ou promotionnelles (si applicable).' }
            ]
          },
          retention: {
            title: '5. Durée de Conservation',
            list: [
              { type: 'Données du compte client', duration: 'Pendant toute la durée d\'activité du compte, puis 3 ans après la résiliation.' },
              { type: 'Données de facturation', duration: '10 ans (obligation légale comptable).' },
              { type: 'Logs techniques', duration: '12 mois maximum.' },
              { type: 'Tickets support', duration: '2 ans à compter de la clôture du ticket.' }
            ]
          },
          sharing: {
            title: '6. Partage des Données',
            intro: 'FIVEMSHIELD ne vend jamais vos données à des tiers. Vos données peuvent être partagées uniquement avec :',
            list: [
              { name: 'Prestataires de paiement', detail: 'Stripe, PayPal — pour le traitement sécurisé des transactions.' },
              { name: 'Hébergeurs d\'infrastructure', detail: 'Nos partenaires datacenter (OVH, Hetzner, etc.) — pour la fourniture des ressources serveur.' },
              { name: 'Outils d\'analyse', detail: 'Uniquement des outils internes (Grafana) — pour la supervision des services, sans transfert vers des tiers publicitaires.' }
            ],
            gdpr: 'Tout sous-traitant est lié par un contrat garantissant la conformité au RGPD.'
          },
          international: {
            title: '7. Transferts Internationaux',
            body: 'Certaines infrastructures peuvent être localisées en dehors de l\'Union Européenne (ex. Amérique du Nord, Asie). Dans ce cas, FIVEMSHIELD s\'assure que les transferts de données sont encadrés par des garanties appropriées (clauses contractuelles types de la Commission Européenne ou décision d\'adéquation).'
          },
          rights: {
            title: '8. Vos Droits',
            intro: 'Conformément au RGPD, vous disposez des droits suivants :',
            list: [
              { right: 'Droit d\'accès', detail: 'obtenir une copie de vos données personnelles.' },
              { right: 'Droit de rectification', detail: 'corriger des données inexactes ou incomplètes.' },
              { right: 'Droit à l\'effacement', detail: 'demander la suppression de vos données (sous réserve des obligations légales).' },
              { right: 'Droit à la limitation', detail: 'limiter le traitement de vos données dans certaines circonstances.' },
              { right: 'Droit à la portabilité', detail: 'recevoir vos données dans un format structuré et lisible.' },
              { right: 'Droit d\'opposition', detail: 'vous opposer au traitement fondé sur l\'intérêt légitime.' },
              { right: 'Droit de retrait du consentement', detail: 'retirer votre consentement à tout moment.' }
            ],
            exercise: 'Pour exercer vos droits, envoyez votre demande à contact@fivemshield.net. Nous nous engageons à répondre dans un délai de 30 jours.',
            cnil: 'Vous avez également le droit d\'introduire une réclamation auprès de la CNIL (www.cnil.fr).'
          },
          cookies: {
            title: '9. Cookies',
            body: 'Le site fivemshield.net utilise uniquement des cookies strictement nécessaires au fonctionnement du site (session, préférence de langue) et des cookies d\'analyse de performance anonymisés. Aucun cookie publicitaire ou de tracking tiers n\'est déposé sans votre consentement explicite.'
          },
          security: {
            title: '10. Sécurité des Données',
            body: 'FIVEMSHIELD met en œuvre des mesures techniques et organisationnelles adaptées pour protéger vos données contre tout accès non autorisé, perte ou divulgation : chiffrement TLS des communications, accès restreint aux données par notre équipe, surveillance continue des infrastructures.'
          },
          changes: {
            title: '11. Modifications',
            body: 'Cette politique peut être mise à jour à tout moment. En cas de modification substantielle, nous vous informerons par email ou via une notification sur le site. La date de dernière mise à jour figure en haut de cette page.'
          },
          contact: {
            title: '12. Contact',
            body: 'Pour toute question relative à la présente politique de confidentialité ou à l\'exercice de vos droits, contactez-nous :',
            email: 'contact@fivemshield.net',
            address: 'xdpfilter — 78 AVENUE des Champs Élysées, 75008 Paris, France – Bureau 326'
          }
        },
        links: {
          intro: 'Consultez également nos',
          legal: 'CGU/CGV',
          about: 'À propos',
          contact: 'Contact'
        }
      }
    }
  },
  en: {
    translation: {
      breadcrumb: {
        home: 'Home'
      },
      seo: {
        home: {
          title: 'FIVEMSHIELD | DDoS Protection & FiveM Hosting - 24/7 Support',
          description:
            'FIVEMSHIELD: specialized FiveM hosting with Anti-DDoS protection, high-frequency VPS, NVMe storage and 24/7 support. Protect your server from L3/L4/L7 attacks.'
        }
      },
      header: {
        logoAria: 'FIVEMSHIELD - Hosting and Anti-DDoS Protection for FiveM servers',
        nav: {
          home: 'Home',
          services: 'Services',
          about: 'About',
          cfxFinder: 'CFX Finder',
          blog: 'Blog',
          contact: 'Contact',
          protection: 'Status',
          login: 'Log in'
        },
        services: {
          vps: { title: 'VPS Game', desc: 'VPS servers optimized for FiveM' },
          proxy: { title: 'Reverse Proxy', desc: 'Stay protected with any host ' },
          cdn: { title: 'CDN & Caching', desc: 'Resource acceleration' },
          panel: { title: 'Game Panel', desc: 'Turnkey FiveM server' },
          vpsWindows: { title: 'VPS Windows', desc: 'Windows VPS servers', badge: 'Soon' },
          antiDdos: { title: 'Anti-DDoS FiveM', desc: 'Dedicated FiveM protection' }
        },
        mobile: {
          support: '24/7 support available',
          getProtection: 'Get protection'
        },
        language: {
          label: 'Language',
          fr: 'FR',
          en: 'EN'
        }
      },
      hero: {
        brand: 'FIVEMSHIELD',
        antiDDoS: 'Anti-DDoS',
        fiveM: ' FiveM',
        tagline:
          '',
        cta: {
          getProtection: 'Get protection',
          learnMore: 'Learn more'
        },
        features: {
          l3l7: 'L3-L7 Protection',
          lowLatency: 'Low Latency',
          globalNetwork: 'Global Network'
        },
        scroll: 'SCROLL',
        stats: { capacity: 'CAPACITY', avgLatency: 'AVERAGE LATENCY' }
      },
      common: {
        perMonth: '/month',
        perLifetime: '/lifetime',
        billing: {
          monthly: {
            label: 'Monthly',
            suffix: '/mo',
            description: 'Cancel anytime'
          },
          quarterly: {
            label: 'Quarterly',
            suffix: '/3 months',
            description: 'Save 5%'
          },
          semiannual: {
            label: 'Semi-annual',
            suffix: '/6 months',
            description: 'Save 10%'
          },
          annual: {
            label: 'Annual',
            suffix: '/year',
            description: 'Save up to 18%'
          },
          monthlyEquivalent: 'Equivalent to {{price}} / month'
        }
      },
      banner: {
        highlight: 'Reverse Proxy',
        product: 'FiveM Anti-DDoS',
        urgency: 'Limited time',
        description: 'Your FiveM server, fully protected in under 2 minutes. 17+ Tbps Anti-DDoS, hidden IP, zero latency — activate protection now.',
        originalPrice: '€39.99/mo',
        fromPrice: 'From €33.99/mo',
        codeLabel: 'Promo code',
        code: 'PROXY15',
        cta: 'Order with -15% off',
        secondaryCta: 'View Reverse Proxy pricing →',
        later: 'Maybe later',
        close: 'Close promotion'
      },
      trust: {
        validatedBy: 'Trusted by {{count}} servers worldwide'
      },
      locations: {
        title: 'Our Points of Presence',
        note: ''
      },
      stats: {
        mitigationCapacity: 'Mitigation capacity',
        uptime: 'Guaranteed uptime',
        addedLatency: 'Added latency',
        pops: 'Points of presence'
      },
      features: {
        badge: 'FiveM Anti-DDoS Suite',
        title: 'Why choose us?',
        subtitle: 'Protection designed for FiveM, with no compromise on performance or player experience.',
        cta: 'Explore our plans',
        metrics: [
          { value: '17+ Tbps', label: 'Global mitigation capacity' },
          { value: '<10 ms', label: 'Average latency EU' },
          { value: '24/7', label: 'SOC & priority support' }
        ],
        items: {
          l3l4l7: {
            title: 'L3/L4/L7 protection tailored for FiveM',
            description: 'Advanced L7 mitigation targeting /info.json, /players.json ... And FiveM TCP & UDP traffic.'
          },
          lowLatency: {
            title: 'Ultra-low latency',
            description: 'Anycast routing for stable ping, even under mitigation.'
          },
          pops: {
            title: 'Global PoPs',
            description: 'Worldwide network, player proximity, smart routing for maximum performance.'
          },
          supportCard: {
            title: 'Priority 24/7 support',
            description: 'FiveM experts available around the clock, fast resolution, professional guidance.'
          },
          redundant: {
            title: 'Redundant infrastructure',
            description: 'Scrubbing centers, automatic failover, and guaranteed high availability.'
          },
          instant: {
            title: 'Instant deployment',
            description: 'Immediate activation, ready-to-use rules, compatible with major resources.'
          }
        },
        support: {
          standard: {
            badge: 'Standard support',
            title: 'Standard support',
            description: 'Our standard support team is available to answer questions and resolve issues.',
            bullets: [
              'Available 11:00 – 22:00 (UTC)',
              'Technical assistance via email & ticket',
              'Average response time: 1 – 2 hours'
            ],
            footer: 'Included with all standard plans'
          },
          premium: {
            badge: 'Premium support',
            title: 'Premium support 24/7',
            description: 'Priority assistance 24/7 for ultra-fast, personalized help.',
            bullets: [
              'Available 24/7, 365 days a year',
              'Priority assistance via ticket & chat',
              'Average response time: 5 minutes'
            ],
            footer: 'Available as an option'
          }
        },
        infra: [
          {
            title: 'Dedicated support',
            description: 'Direct escalation to our SOC engineers for critical incidents.'
          },
          {
            title: 'Redundant infrastructure',
            description: 'Scrubbing centers, automatic failover, high availability.'
          },
          {
            title: 'Custom playbooks',
            description: 'Runbooks and automations tailored to your large events.'
          }
        ]
      },
      diagram: {
        incoming: 'Incoming traffic',
        ddosAnalysis: 'DDoS analysis',
        filtering: 'Filtering & Scrubbing',
        loadBalancing: 'Load Balancing',
        fivemServer: 'FiveM Server'
      },
      partnersBanner: {
        poweredBy: 'Powered by the best technologies'
      },
      footer: {
        description:
          'Provider of premium security solutions for FiveM servers. Protect your community with our advanced DDoS protection.',
        quickLinks: {
          title: 'Quick Links',
          home: 'Home',
          about: 'About',
          legal: 'Terms',
          privacy: 'Privacy Policy',
          contact: 'Contact'
        },
        services: {
          title: 'Our Services',
          reverseProxy: 'Reverse Proxy',
          vps: 'VPS',
          cdn: 'CDN & Caching',
          panel: 'Game Panel'
        },
        contact: {
          title: 'Contact Us',
          discordJoin: 'Join our Discord'
        },
        copyright: 'All rights reserved.'
      },
      contactPage: {
        breadcrumb: 'Contact',
        seo: {
          title: 'Contact | FIVEMSHIELD',
          description: "Contact FIVEMSHIELD via Discord, WhatsApp or from the Client Area for any questions about FiveM hosting and Anti-DDoS protection."
        },
        hero: {
          title: "Let's talk about",
          titleHighlight: 'your project.',
          subtitle: 'Whether you have a technical question, need help with your server, or a sales inquiry, our team is available and responsive.'
        },
        trust: [
          { value: '<15 min', label: 'Average response time' },
          { value: '24/7', label: 'Support availability' },
          { value: '450+', label: 'Protected servers' }
        ],
        cards: {
          discord: {
            title: 'Discord',
            description: 'Join our community of 1000+ members. Community support, announcements and direct exchanges with our team.',
            action: 'Join the server',
            response: 'Response in ~15 min'
          },
          support: {
            title: 'Client Area',
            description: 'Open a ticket for any in-depth technical request or related to your account billing.',
            action: 'Open a ticket',
            response: 'Response in ~1h'
          },
          whatsapp: {
            title: 'WhatsApp',
            description: 'Contact us directly for a quick response or for any urgent business inquiry.',
            action: 'Send a message',
            response: 'Response in ~30 min'
          }
        },
        faq: {
          title: 'Frequently asked questions',
          items: [
            { question: 'What is the best way to contact you?', answer: 'For quick support, open a ticket on Discord. For sales inquiries, use WhatsApp or a ticket in your Client Area.' },
            { question: 'What are your response times?', answer: 'Our average response time is under 15 minutes on Discord. Client Area tickets are handled in less than one hour.' },
            { question: 'Do you offer setup assistance?', answer: 'Yes, our team assists you free of charge in configuring your protection and services.' }
          ]
        },
        links: {
          discover: 'Also discover:',
          vps: 'FiveM VPS',
          reverse: 'Reverse Proxy',
          about: 'About Us'
        }
      },
      about: {
        breadcrumb: 'About',
        seo: {
          title: 'About FIVEMSHIELD | Our Story & Team',
          description: 'Discover the story of FIVEMSHIELD, from the first idea to protecting hundreds of FiveM servers. Meet the team behind the best FiveM Anti-DDoS protection.'
        },
        hero: {
          kicker: 'Our Story',
          title: 'Born from chaos.',
          titleHighlight: 'Built to protect.',
          subtitle: "It started with crashed servers and disconnected players. Nobody was protecting FiveM properly. So we did it ourselves."
        },
        story: {
          chapter1: {
            kicker: 'The origin',
            year: '2023',
            title: 'A frustration turned mission',
            paragraphs: [
              "In 2023, Lucas and Théo were running their own FiveM servers. Every week, the same story: DDoS attacks paralyzed their communities for hours. The existing solutions? Too expensive, too slow, not built for FiveM protocol.",
              "That day, they made a decision that would change everything: build the protection nobody offered. Not a generic proxy. Not a standard firewall. A solution designed from scratch for FiveM."
            ]
          },
          chapter2: {
            kicker: 'The technology',
            year: '2024',
            title: 'XDP, eBPF & kernel-bypass filtering',
            paragraphs: [
              "Where others slap on a CDN and call it protection, we wrote our own mitigation engine. Built on XDP and eBPF, it filters packets at the kernel-bypass level at over 100 million packets per second.",
              "Every FiveM flow is inspected statefully. We understand the protocol, we can differentiate a real player from a bot. Result: zero false positives, zero added latency."
            ]
          },
          chapter3: {
            kicker: 'The expansion',
            year: '2024-2025',
            title: '17+ Tbps, BGP Anycast, multi-PoP',
            paragraphs: [
              "Our network grew. Scrubbing centers across Europe, BGP Anycast routing to direct traffic to the nearest node. Over 17 Tbps of absorption capacity.",
              "Then VPS. The 1-click Panel. CDN & Caching. Every building block was built with the same obsession: your players should never notice there was an attack."
            ]
          }
        },
        stats: {
          servers: { value: '450+', label: 'Servers protected' },
          capacity: { value: '17+ Tbps', label: 'Mitigation capacity' },
          latency: { value: '<10 ms', label: 'Average latency EU' },
          uptime: { value: '99.99%', label: 'Uptime SLA' }
        },
        values: {
          kicker: 'Our values',
          title: 'What we believe in',
          items: [
            { title: 'Transparency', description: "No marketing BS. We say what we do, we do what we say. Our stats are real, our promises kept." },
            { title: 'Performance', description: 'Every millisecond counts. Our infrastructure is optimized so your players never feel the protection.' },
            { title: 'Innovation', description: "We don't copy existing solutions. We develop our own technologies, in-house, specifically tailored for FiveM." },
            { title: 'Community', description: "We're gamers first. We protect FiveM because we love FiveM. Every decision is guided by the community." }
          ]
        },
        team: {
          kicker: 'The team',
          title: 'The faces behind the shield',
          subtitle: 'Two cybersecurity and FiveM enthusiasts who decided to change the rules of the game.',
          members: {
            lucas: {
              role: 'Founder & CEO',
              description: "Network security expert with 6+ years of experience. Lucas architected the entire FIVEMSHIELD infrastructure and leads the product vision."
            },
            theo: {
              role: 'Anti-DDoS Engineer',
              description: "The man behind our XDP/eBPF mitigation engine. Théo develops and optimizes the algorithms that protect your servers in real time."
            }
          }
        },
        cta: {
          title: 'Ready to secure your server?',
          subtitle: 'Join the hundreds of servers that trust us. Protection activated in minutes.',
          primary: 'Discover our services',
          secondary: 'Contact us'
        },
        links: {
          discover: 'Discover our services:'
        }
      },
      vps: {
        breadcrumb: 'FiveM VPS',
        seo: {
          title: 'FiveM VPS High Frequency | Anti-DDoS Included | FIVEMSHIELD',
          description: 'FiveM-optimized VPS with 5.20GHz CPU, ultra-fast NVMe and built-in Anti-DDoS protection. Ideal for 50 to 150+ players.'
        },
        hero: {
          kicker: 'Premium FiveM hosting',
          title: 'FiveM VPS & Anti-DDoS',
          subtitle:
            '5.20GHz CPUs, Gen4 NVMe, proprietary L3/L4/L7 mitigation and priority support to keep your community online at all times.',
          badges: {
            dedicated: 'FiveM-specific Anti-DDoS',
            uptime: '99.95% SLA',
            support: 'Priority support 24/7'
          },
          checklist: [
            'Instant provisioning through our secure manager',
            'Guided migration handled by a FiveM engineer',
            'Real-time monitoring & proactive alerts'
          ],
          highlights: {
            players: { value: '450+', label: 'FiveM servers protected' },
            latency: { value: '<15 ms', label: 'average latency EU' },
            mitigation: { value: '17+ Tbps', label: 'global mitigation capacity' }
          },
          rating: {
            value: '4.9/5',
            caption: '87 verified reviews · 450+ servers protected'
          },
          priceFrom: {
            value: 'From €39.99',
            suffix: '/mo — no contract'
          },
          guarantees: [
            '5-minute activation',
            'Cancel anytime',
            'Anti-DDoS included'
          ],
          ticker: {
            label: 'Requests filtered live'
          },
          ctaOrderNow: 'Order now',
          ctaSeeOffers: 'View plans',
          ctaTalk: 'Talk to an expert',
          liveBadge: 'System operational',
          imageAlt: 'High-performance FiveM VPS'
        },
        trustBar: [
          'Instant provisioning',
          'L3/L4/L7 Anti-DDoS',
          '99.998% uptime',
          '10 PoP network',
          '24/7 support',
          'Masked IP'
        ],
        trust: {
          title: 'Trusted by the busiest FiveM roleplay communities',
          subtitle:
            'Whitelisted networks, public servers and studios rely on FIVEMSHIELD to secure their infrastructure.'
        },
        plans: {
          pretitle: 'Hosting + protection',
          title: 'Our FiveM VPS plans',
          subtitle: 'Pick the dedicated resources that match your FiveM player base.',
          recommended: 'RECOMMENDED',
          select: 'Choose this plan',
          outOfStock: 'OUT OF STOCK',
          outOfStockCta: 'Unavailable',
          includes: 'Every plan includes:',
          globalFeatures: [
            'Layer 3/4/7 FiveM-tuned Anti-DDoS protection',
            '25 Gbit/s bandwidth & live monitoring',
            'FIVEMSHIELD dashboard & API access',
            'Automatic snapshots and daily backups'
          ],
          ddosUpgrade: {
            title: 'Ultra DDoS Protection',
            price: '€30/month',
            description: 'Add Ultra DDoS protection to your VPS for enhanced security. Standard plans already include good protection, but this option provides maximum effectiveness against the most sophisticated attacks.',
            badge: 'Optional add-on',
            features: [
              'Advanced behavioral filtering',
              'Absorbs the most sophisticated attacks',
              'Instant activation'
            ]
          },
          core: {
            badge: 'Essential',
            price: '€19.99',
            description: 'Perfect to launch your RP community with up to 30 concurrent players.',
            features: [
              '4 vCore AMD R9 7950X3D @ 5.20GHz',
              '8 GB DDR5 ECC RAM',
              '40 GB NVMe Gen4',
              'Unlimited traffic / 25 Gbit/s',
              'Standard support 7 days a week'
            ]
          },
          stealth: {
            badge: 'Growth',
            price: '€39.99',
            description: 'The right fit for a growing RP community of 30 to 80 players.',
            features: [
              '6 vCore AMD R9 7950X3D @ 5.20GHz',
              '16 GB DDR5 ECC RAM',
              '80 GB NVMe Gen4',
              'Stage 1 DDoS protection',
              'Priority support & 24/7 monitoring'
            ]
          },
          storm: {
            badge: 'High traffic',
            price: '€59.99',
            description: 'Built for high-traffic RP servers running 80 to 150 players.',
            features: [
              '8 vCore AMD R9 7950X3D @ 5.20GHz',
              '32 GB DDR5 ECC RAM',
              '120 GB NVMe Gen4',
              'Stage 2 DDoS protection',
              'Dedicated technical advisor'
            ]
          },
          titan: {
            badge: 'Enterprise',
            price: '€99.99',
            description: 'Designed for multi-server networks and communities of 150+ players.',
            features: [
              '12 vCore AMD R9 7950X3D @ 5.20GHz',
              '42 GB DDR5 ECC RAM',
              '240 GB NVMe Gen4',
              'Stage 2 DDoS protection',
              '24/7 TAM support & contractual SLA'
            ]
          },
          contact: 'Need bare-metal or multi-VPS architecture?',
          contactCta: 'Talk with sales'
        },
        features: {
          title: 'Performance engineered for FiveM',
          subtitle:
            '5.20GHz compute, Gen4 NVMe and a shielded 25 Gbit/s network supervised by our SOC for rock-solid uptime.',
          items: {
            cpu: {
              title: 'High-frequency CPUs',
              description: 'AMD R9 7950X3D nodes locked at 5.20GHz to keep your server tick rate consistent.'
            },
            storage: {
              title: 'Gen4 NVMe storage',
              description: 'Extreme IOPS so resources, databases and assets load instantly.'
            },
            network: {
              title: 'Segmented 25 Gbit/s network',
              description: 'Premium peering, BGP Anycast and optimized routing toward the EU FiveM scene.'
            },
            shield: {
              title: 'Proprietary Anti-DDoS shield',
              description: 'Behavioral profiling on /players.json, TCP/UDP handshakes and adaptive L7 filtering.'
            }
          }
        },
        stack: {
          title: 'FIVEMSHIELD protection suite',
          subtitle: 'A complete filtering and observability pipeline built for FiveM traffic.',
          description: 'Every VPS plan comes with our advanced modules to inspect, filter and visualize your traffic.',
          cards: [
            {
              title: 'Layer 7 behavioral filtering',
              description: 'Dynamic signatures on /info.json, /players.json and FiveM-specific endpoints.'
            },
            {
              title: 'Distributed 10 Tbps scrubbing',
              description: 'Multi-region centers that absorb volumetric and application attacks.'
            },
            {
              title: 'Dashboard & alerting',
              description: 'Real-time metrics, Discord webhooks and API export for your internal tools.'
            }
          ]
        },
        support: {
          title: 'Operational partnership',
          subtitle: 'More than a host, a dedicated teammate.',
          description:
            'Our FiveM engineers monitor your peak hours, prep major events and escalate to the SOC whenever required.',
          badge: 'Priority support & SOC escalation',
          items: [
            {
              title: 'Tailored onboarding',
              description: 'Hardening checklist, txAdmin/CFX setup and optimization of your critical scripts.'
            },
            {
              title: 'Proactive observability',
              description: 'Latency, CPU and attack alerts delivered to the communication channel of your choice.'
            },
            {
              title: '24/7 incident management',
              description: 'Direct escalation to an engineer whenever your server is targeted or saturated.'
            }
          ]
        },
        faq: {
          title: 'Frequently asked questions about our FiveM VPS',
          subtitle: 'Everything you need before migrating to FIVEMSHIELD.',
          items: [
            {
              question: 'Which plan should I pick for my FiveM server?',
              answer:
                'StealthEdge fits communities of 30 to 80 players, StormGuard secures 80 to 150-player servers and TitanShield is built for multi-instance networks of 150+ players. Every plan includes the same proprietary Anti-DDoS stack.'
            },
            {
              question: 'How do you keep latency so low?',
              answer:
                'We operate AMD 5.20GHz nodes in Paris with premium peering, Anycast routing and continuous monitoring to maintain <15 ms latency across EU'
            },
            {
              question: 'Is Anti-DDoS protection included?',
              answer:
                'Yes, multilayer L3/L4/L7 mitigation is bundled. It filters FiveM endpoints and absorbs up to 10 Tbps of attacks without extra cost.'
            },
            {
              question: 'Can you migrate my existing server?',
              answer:
                'Absolutely. Our team imports your txAdmin/CFX backups, validates key resources and switches your community with zero downtime.'
            }
          ]
        },
        cta: {
          badge: 'Ready to start?',
          title: 'Launch your shielded FiveM server in under 10 minutes',
          subtitle: 'Order online or schedule a call with a solutions engineer.',
          primary: 'Create my VPS now',
          primaryDesc: 'Guided setup, live in minutes.',
          secondary: 'Schedule a call',
          secondaryDesc: 'Talk to a solutions engineer before you commit.'
        }
      },
      vpsWindows: {
        seo: {
          title: 'Windows VPS from €64.99 | Windows Server 2025 + Anti-DDoS',
          description: 'FiveM Windows VPS: 4.2GHz CPU, NVMe, Windows Server 2025 pre-installed, 17+ Tbps Anti-DDoS INCLUDED. 100 to 300+ players. Instant activation.'
        },
        hero: {
          title: 'Windows VPS & Anti-DDoS',
          subtitle: '5.20GHz CPU, NVMe Gen4 storage, pre-installed Windows Server and proprietary L3/L4/L7 protection to keep your community online.',
          rating: {
            value: '4.9/5',
            caption: '87 verified reviews · 450+ protected servers'
          },
          priceFrom: {
            value: 'From €64.99',
            suffix: '/month — no commitment'
          },
          ctaOrderNow: 'Order now',
          ctaSeeOffers: 'See offers'
        },
        plans: {
          pretitle: 'Windows VPS + Protection',
          title: 'Our Windows VPS Plans',
          subtitle: 'Choose the Windows configuration that fits your community size.',
          recommended: 'RECOMMENDED',
          select: 'Choose this plan',
          includes: 'Included in all plans:',
          globalFeatures: [
            'Windows Server 2025 pre-installed and activated',
            'L3/L4/L7 Anti-DDoS Protection',
            '10 Gbit/s bandwidth + real-time monitoring',
            'FIVEMSHIELD Dashboard & API'
          ],
          ddosUpgrade: {
            title: 'Ultra DDoS Protection',
            price: '€30',
            description: 'Add Ultra DDoS Protection to your Windows VPS for enhanced security against the most sophisticated attacks.',
            features: [
              'Advanced behavioral filtering',
              'Absorption of the most sophisticated attacks',
              'Instant activation'
            ]
          },
          ironbyte: {
            badge: 'Essential',
            description: 'Ideal for Windows communities up to 100+ players.',
            features: [
              '6 vCores 4.20GHz',
              '16 GB DDR5 ECC RAM',
              '120 GB NVMe Gen4',
              'DDoS Protection Stage 1',
              'Windows Server 2025 included',
              'Standard support 7 days/week'
            ]
          },
          steelforge: {
            badge: 'High traffic',
            description: 'Built for Windows servers up to 180+ players.',
            features: [
              '8 vCores 4.20GHz',
              '32 GB DDR5 ECC RAM',
              '160 GB NVMe Gen4',
              'DDoS Protection Stage 2',
              'Windows Server 2025 included',
              '24/7 Priority support'
            ]
          },
          fireguard: {
            badge: 'Enterprise',
            description: 'Designed for multi-server networks and 300+ player communities.',
            features: [
              '12 vCores 4.20GHz',
              '48 GB DDR5 ECC RAM',
              '300 GB NVMe Gen4',
              'DDoS Protection Stage 2',
              'Windows Server 2025 included',
              '24/7 TAM Support & SLA'
            ]
          },
          contact: 'Need a custom or multi-VPS configuration?',
          contactCta: 'Contact sales'
        },
        faq: {
          title: 'Windows VPS FAQ',
          subtitle: 'Everything you need to know before migrating to FIVEMSHIELD.',
          items: [
            {
              question: 'Which Windows version is installed?',
              answer: 'All our Windows VPS come with Windows Server 2025 Datacenter, pre-installed and activated. You have full administrator access upon delivery.'
            },
            {
              question: 'Is the Windows license included?',
              answer: 'Yes, the Windows Server license is included in the plan price. No additional cost for the operating system.'
            },
            {
              question: 'Can I install my own software?',
              answer: 'Absolutely. You have full administrator access via RDP. Install txAdmin, your FiveM scripts, SQL Server, or any other software you need.'
            },
            {
              question: 'Does Anti-DDoS protection work with Windows?',
              answer: 'Yes, our Anti-DDoS protection is identical on Linux and Windows. It filters L3/L4/L7 attacks before they reach your server.'
            }
          ]
        },
        cta: {
          title: 'Launch your Windows VPS in under 10 minutes',
          subtitle: 'Order online or schedule a call with a solutions engineer.',
          primary: 'Create my Windows VPS',
          secondary: 'Schedule a call'
        }
      },
      footerV2: {
        newsletterCta: 'Join our Discord community',
        headline1: 'Host.',
        headline2: 'Protect.',
        headline3: 'Dominate.',
        ctaCard: {
          title: 'Activate your protection',
          description: 'Set up in under 10 minutes. Anti-DDoS included, 24/7 support.',
          badge: '99.99% SLA'
        },
        watermark: 'FIVEMSHIELD'
      },
      panel: {
        breadcrumb: 'FiveM Panel',
        relaunch: {
          kicker: 'Game Panel',
          title: 'Your FiveM server online in under a minute',
          subtitle: 'Built for small communities. DDoS protection included, no command line.',
          facts: [
            { value: '< 1 min', label: 'To go live' },
            { value: 'Included', label: 'Anti-DDoS' },
            { value: 'from €3.99', label: 'Per month' }
          ],
          ctaPrimary: 'Pick a plan',
          ctaSecondary: 'How it works'
        },
        steps: {
          kicker: 'Setup',
          title: 'Three steps, one minute',
          items: [
            { time: '0:00', title: 'Pick your plan', desc: 'Pay, then get instant panel access.' },
            { time: '0:20', title: 'Choose a template', desc: 'RP, drift or free access, preconfigured.' },
            { time: '0:45', title: 'Your server is live', desc: 'Protected, monitored, ready for players.' }
          ]
        },
        migration: {
          kicker: 'Migration',
          title: 'Switch hosts without starting from scratch',
          body: 'Coming from another host? Connect to your old server and the panel imports your resources and server.cfg automatically, in a few clicks.',
          points: [
            'SFTP or FTP, used only for the import',
            'You choose what gets transferred',
            'Resources and server.cfg pulled in automatically',
          ],
        },
        gallery: {
          kicker: 'A look inside',
          title: 'The panel, for real'
        },
        included: {
          title: 'In every plan',
          items: ['Anti-DDoS protection', 'Automatic backups', 'CPU / RAM monitoring', '24/7 support']
        },
        finalCta: {
          title: 'Ready to launch your server?',
          subtitle: 'No commitment. Change plan whenever you want.',
          button: 'Get started'
        },
        seo: {
          title: 'FiveM Hosting Provider | Game Panel from €3.99, DDoS Included | FIVEMSHIELD',
          description:
            'FIVEMSHIELD, specialized FiveM hosting provider: Game Panel built for small communities, DDoS protection included, live in under a minute, no command line needed. Plans from €3.99/month.',
          keywords:
            'fivem hosting provider, best fivem hosting, fivem game panel, cheap fivem panel, fivem small server hosting, fivem panel ddos protection, fivem 1-click server management, fxserver panel, fivem panel for beginners'
        },
        hero: {
          kicker: 'Managed FiveM panel',
          title: 'Run your FiveM server without scripts or CLI',
          subtitle: 'Deploy, automate and monitor every instance from a cockpit built for modern RP teams.',
          bullets: [
            'Ready-to-use RP, drift and freeroam templates',
            'Centralized resource, backup and txAdmin control',
            'CPU/RAM monitoring plus Discord alerts included'
          ],
          stats: [
            { value: '1 min', label: 'Average install time' },
            { value: '12+ automations', label: 'Restarts & snapshots' },
            { value: '24/7', label: 'Priority support' }
          ],
          ctaPrimary: 'Start for free',
          ctaSecondary: 'See features'
        },
        features: {
          kicker: 'Features',
          title: 'A cockpit built for FiveM',
          subtitle: 'Every module is tuned for RP staff workflows.',
          items: [
            {
              title: '1-click deployment',
              description: 'Spin up RP, drift or creative servers in 60 seconds with curated scripts.'
            },
            {
              title: 'Automations & snapshots',
              description: 'Smart restarts, scheduled backups and instant rollbacks.'
            },
            {
              title: 'Integrated monitoring',
              description: 'CPU/RAM metrics, txAdmin logs and Discord alerts with zero extra config.'
            },
            {
              title: 'Priority support',
              description: 'Direct escalation to our FiveM engineers during critical events.'
            }
          ]
        },
        plans: {
          specs: { cpu: 'Ryzen 7950X CPU threads', ram: 'DDR5 memory', storage: 'NVMe storage', cta: 'Order now', ddos: 'FIVEMSHIELD DDoS Protection Included' },
          selector: 'Drag to adjust the power',
          kicker: 'Monthly plans',
          title: 'Pick the pace that fits',
          subtitle: 'No long-term commitment. Upgrade instantly.',
          items: [
            { name: 'Scout', price: '€3.99', threads: '1', ram: '1', storage: '10' },
            { name: 'Patrol', price: '€6.99', threads: '2', ram: '2', storage: '20' },
            { name: 'Guard', price: '€12.99', threads: '2', ram: '4', storage: '50' },
            { name: 'Sentry', price: '€27.50', threads: '3', ram: '8', storage: '100', badge: 'Most popular' },
            { name: 'Ranger', price: '€39.99', threads: '4', ram: '12', storage: '150' },
            { name: 'Vanguard', price: '€54.99', threads: '6', ram: '16', storage: '200' },
            { name: 'Bastion', price: '€64.99', threads: '6', ram: '20', storage: '200' },
            { name: 'Citadel', price: '€79.99', threads: '8', ram: '25', storage: '300' },
            { name: 'Fortress', price: '€110.00', threads: '12', ram: '32', storage: '300' },
          ]
        },
        lifetime: {
          kicker: 'Lifetime',
          title: 'Pay once, run forever',
          subtitle: 'Perfect for streamers and studios needing a permanent license.',
          badge: 'Perpetual license',
          items: [
            {
              name: 'Lifetime Basic',
              description: 'Lifetime license for a single FiveM server.',
              price: '€49.99',
              bullets: [
                '4 vCPU AMD @ 5.20GHz',
                '4 GB RAM • 40 GB NVMe',
                'Priority support'
              ],
              cta: 'Order now'
            },
            {
              name: 'Lifetime Plus',
              description: 'For public or whitelist servers.',
              price: '€99.99',
              bullets: [
                'Anti-DDoS protection: Anti-DDoS Ultra',
                '6 vCPU AMD @ 5.20GHz',
                '8 GB RAM • 80 GB NVMe',
                'Priority support'
              ],
              cta: 'Order now'
            },
            {
              name: 'Lifetime Ultra',
              description: 'Studios and multi-server networks.',
              price: '€149.99',
              bullets: [
                'Anti-DDoS protection: Anti-DDoS Ultra+',
                '8 vCPU AMD @ 5.20GHz',
                '16 GB RAM • 160 GB NVMe',
                'Priority support'
              ],
              cta: 'Order now'
            }
          ]
        },
        preview: {
          title: 'Panel preview',
          subtitle: 'Responsive UI, desktop & mobile ready.',
          alt: 'FIVEMSHIELD panel interface preview'
        },
        faq: {
          title: 'Frequently asked questions',
          subtitle: 'Everything you need to know before switching.',
          items: [
            {
              question: 'Does the panel require txAdmin?',
              answer:
                'Yes, we rely on txAdmin for the runtime layer but automate repetitive tasks and expose a simplified graphical interface.'
            },
            {
              question: 'Can I import my existing server?',
              answer:
                'Absolutely. The wizard ingests your resources, databases and custom scripts. An engineer can assist you for free during the migration.'
            },
            {
              question: 'How are backups handled?',
              answer:
                'Incremental snapshots, S3/Backblaze exports and optional pushes to your own bucket. Restorations happen in one click.'
            },
            {
              question: 'Is the panel available on mobile?',
              answer:
                'Yes, the UI is fully responsive and we offer a PWA/mobile mode so you can receive critical alerts and trigger restarts on the go.'
            }
          ],
          footer: 'FIVEMSHIELD • Panel + Anti-DDoS + Reverse Proxy'
        }
      },
      reverse: {
        breadcrumb: 'Reverse Proxy',
        seo: {
          title: 'FiveM Reverse Proxy | Ultimate Anti-DDoS Protection | FIVEMSHIELD',
          description:
            'Protect your FiveM server with our Reverse Proxy: IP masking, L3/L4/L7 DDoS mitigation, 0ms added latency. 10-min setup. 17+ Tbps capacity.'
        },
        hero: {
          kicker: 'Anti-DDoS Reverse Proxy',
          title: 'Keep your host.',
          subtitle:
            'We protect your FiveM server with 2 lines in your server.cfg. Your IP disappears and DDoS attacks are blocked — no migration, nothing to change with your current host.',
          points: [
            'Guided setup in under 10 minutes',
            'Your real IP stays 100% hidden',
            '24/7 active protection with real-time monitoring'
          ],
          stats: [
            { value: '17+ Tbps', label: 'Global absorption capacity' },
            { value: '0 ms', label: 'Added latency' },
            { value: '99.99%', label: 'Guaranteed availability' }
          ],
          ctaPrimary: 'Setup my protection',
          ctaSecondary: 'Talk to an expert',
          cardTitle: 'Why choose our Reverse Proxy?',
          cardSubtitle: 'FiveM-specialized protection with intelligent filtering of /info.json, /players.json endpoints and behavioral traffic analysis.',
          cardNote: 'No hosting changes required • Instant activation • 24/7 dedicated support',
          compatibility: {
            label: 'Works with your current host',
            hosts: ['OVHcloud', 'Hetzner', 'Contabo', 'Kimsufi', 'And many more']
          }
        },
        howItWorks: {
          kicker: 'How it works',
          title: '3 steps, zero migration',
          subtitle: 'No need to switch hosts or touch your existing setup.',
          steps: [
            {
              title: 'You keep your host',
              description: 'Your server stays exactly where it is today.'
            },
            {
              title: 'You add 2 lines to your server.cfg',
              description: 'We send you the exact config to copy-paste. Takes less than 10 minutes.'
            },
            {
              title: 'Your IP disappears, protection activates',
              description: 'Players connect through our reverse proxy. Your real IP is never visible or attackable again.'
            }
          ]
        },
        features: {
          kicker: 'Multi-Layer Protection',
          title: 'Total security for your FiveM server',
          subtitle: 'Every protection layer is optimized for FiveM server specific needs.',
          items: [
            {
              title: 'Complete L3/L4/L7 DDoS Protection',
              description: 'Automatic mitigation of volumetric, protocol and application attacks. Intelligent filtering of malicious requests targeting your FiveM endpoints.'
            },
            {
              title: 'Absolute IP Masking',
              description: 'Your real IP stays completely hidden. Only our distributed Anycast addresses are exposed, making your server untraceable for attackers.'
            },
            {
              title: 'Guaranteed Performance & Stability',
              description: 'Intelligent Anycast routing, Tier-1 peering and TCP/UDP optimization. Your players enjoy ultra-low latency and stable connections.'
            },
            {
              title: 'Real-Time Monitoring & Alerts',
              description: 'Complete dashboard, instant Discord/Webhook notifications and detailed reports. Visualize every blocked attack in real-time.'
            }
          ]
        },
        steps: {
          kicker: 'Setup',
          title: 'Active protection in under 10 minutes',
          subtitle: 'Our technical team handles all configuration for you.',
          items: [
            {
              title: '1. Free infrastructure audit',
              description: 'Analysis of your ports, FiveM configuration, critical scripts and specific needs. We prepare a custom configuration for your server.'
            },
            {
              title: '2. DNS configuration & activation',
              description: 'Setup of DNS records or GRE tunnel based on your preference. Complete load tests and performance validation before going live.'
            },
            {
              title: '3. Active protection & 24/7 monitoring',
              description: 'Your server is protected! Access to monitoring dashboard, configurable alerts and priority technical support available anytime.'
            }
          ]
        },
        stack: {
          title: 'FIVEMSHIELD protection infrastructure',
          subtitle: 'Cutting-edge technology included in every plan.',
          cards: [
            {
              title: 'Scrubbing Centers 17+ Tbps',
              description: 'Distributed network across 8 points of presence capable of absorbing the largest volumetric and application DDoS attacks.'
            },
            {
              title: 'BGP Anycast Routing',
              description: 'Multi-PoP announcement with automatic failover. Your players always connect to the closest point for minimal latency.'
            },
            {
              title: '24/7 SOC & Intelligent Escalation',
              description: 'Security operations center active 24/7. Custom rules, post-incident reports and priority technical assistance.'
            }
          ]
        },
        calculator: {
          kicker: 'Pricing',
          title: 'How much does protection cost for your server?',
          subtitle: 'Transparent pricing based on your player capacity. No hidden fees.',
          capacity: 'Server capacity',
          players: 'players',
          priceLabel: 'Monthly price',
          perMonth: '/month',
          hint: 'Need protection for 800+ players? Contact our sales team for a custom quote.',
          cta: 'Start now',
          sliderMin: '50 players',
          sliderMax: '800 players',
          includes: [
            'Full L3/L4/L7 protection',
            'Complete IP masking',
            '24/7 support included',
            'Setup in 10 min'
          ]
        },
        serverCfg: {
          badge: 'Universal integration',
          title: 'Works with any hosting provider',
          subtitle: 'No migration, no host change. Two lines in your server.cfg and that\'s it — our team handles the rest.',
          note: 'Our team sends you the exact lines to copy-paste. Up and running in under 10 minutes.',
          compatible: 'Compatible with all hosting providers',
          recommended: 'Recommended partner',
          recommendedDesc: 'We recommend OVHcloud for its European infrastructure, network stability and optimized peering — an ideal foundation to get the most out of our reverse proxy.',
          commentLine: '# Add these 2 lines to your server.cfg',
          lastLine: '# That\'s it — our team handles the rest'
        },
        customDomain: {
          badge: 'New feature',
          title: 'Your own connection subdomain',
          subtitle: 'No more impersonal addresses. Your players connect through your own subdomain — a clean, memorable link that reflects your brand 100%.',
          beforeLabel: 'Before',
          beforeTag: 'Generic',
          beforeDesc: 'A shared address that\'s hard to remember and doesn\'t reflect your brand.',
          afterLabel: 'With FIVEMSHIELD',
          afterTag: 'Protected',
          afterDesc: 'Your own custom subdomain, unique to your server, memorable and professional.'
        },
        keyPoints: [
          { title: 'L3/L4/L7 Protection', desc: 'Automatic mitigation of volumetric and application-layer attacks targeting your FiveM endpoints.' },
          { title: 'Full IP Masking', desc: 'Your real IP stays hidden. Only our Anycast addresses are exposed to attackers.' },
          { title: '0 ms added latency', desc: 'Optimized Anycast routing. Your players see no difference, except better stability.' }
        ],
        finalCta: {
          title: 'Ready to protect your FiveM server?',
          subtitle: 'Join hundreds of servers trusting FIVEMSHIELD for their security.',
          start: 'Activate my protection',
          talk: 'Talk to an expert'
        },
        faq: {
          title: 'Frequently asked questions',
          subtitle: 'Everything you need to know about our Reverse Proxy.',
          items: [
            {
              question: 'Will this slow down my server?',
              answer:
                'No, absolutely not! Our Anycast infrastructure adds 0ms latency. In fact, most of our clients even notice improved stability thanks to our optimized routing and Tier-1 peering.'
            },
            {
              question: 'Do I need to change hosting providers?',
              answer:
                'Not at all. Our Reverse Proxy works with any hosting provider. You keep your current server, we simply add a protection layer in front. No migration required.'
            },
            {
              question: 'How long does setup take?',
              answer:
                'Complete configuration typically takes 10 to 30 minutes. Our technical team guides you through every step: audit, DNS/GRE configuration, testing and activation. You\'re protected the same day.'
            },
            {
              question: 'What happens during a DDoS attack?',
              answer:
                'Our system automatically detects and filters malicious traffic in real-time. Attacks are absorbed by our scrubbing centers without impacting your players. You receive alerts and can track the attack live on your dashboard.'
            },
            {
              question: 'What\'s the largest attack you can block?',
              answer:
                'Our infrastructure can absorb attacks up to 17+ Tbps. We\'ve already protected our clients against attacks exceeding 8 Tbps with zero service interruption.'
            },
            {
              question: 'Can I use my own subdomain for player connections?',
              answer:
                'Yes, it\'s included! Your players can connect through your own subdomain (e.g. play.your-server.com) instead of a generic address. Our team sets up the DNS, SSL and FiveM SRV record in under 10 minutes. You keep full control of your domain and your real IP stays completely hidden.'
            }
          ]
        }
      },

      home: {
        newVpsWindows: {
          badge: 'New',
          text: 'Discover our VPS Windows Server 2025 plans',
          cta: 'Discover now'
        },
        underAttack: {
          badge: 'Under Attack?',
          title: 'Contact us directly',
          description: 'We handle everything — complete migration & protection for your FiveM server.',
          cta: 'Contact us now'
        },
        hero: {
          cta: {
            learnMore: 'Learn more'
          }
        },
        protection: {
          title: 'Proprietary XDP Mitigation',
          paragraph:
            'We built our own mitigation stack powered by XDP (eXpress Data Path) and eBPF, operating directly at the NIC driver level for kernel-bypass filtering at 100+ Mpps. Our technology neutralizes L3/L4/L7 attacks before they even reach userspace.',
          bullets: {
            heuristic: 'XDP/eBPF Filtering — Kernel-space packet processing with sub-microsecond latency and stateful inspection of FiveM TCP/UDP flows',
            anycast: 'Distributed 17+ Tbps Scrubbing — Multi-PoP BGP Anycast infrastructure with GRE/IPIP tunneling and ECMP load-balancing',
            tls: 'L7 Deep Packet Inspection — Protocol-aware analysis of FiveM endpoints (/info.json, /players.json) with adaptive rate-limiting and JA3 fingerprinting'
          }
        },
        dashboard: {
          title: 'All-in-one Dashboard',
          paragraph:
            'FIVEMSHIELD services require no manual interaction. However, for those who find a dashboard useful, we built a portal including passed/blocked bandwidth, attack incidents, and filtered ports. You can also track bandwidth for a specific IP.',
          bullets: {
            realtime: 'Real-time tracking of attack attempts',
            bandwidth: 'Graphical bandwidth visualization',
            history: 'Detailed incident history'
          }
        },
        diagram: {
          title: 'How our protection works',
          paragraph:
            'Our intelligent system filters attacks while optimizing legitimate traffic to your FiveM server.'
        },
        solutions: {
          title: 'Our Solutions',
          paragraph:
            'Discover our offers specifically designed to meet all your FiveM hosting and protection needs.'
        },
        guarantee: '48h money-back guarantee · No commitment · Responsive support',
        priceFrom: 'from',
        pricePeriod: '/mo',
        infra: {
          stack: {
            kicker: 'Our technology',
            title: 'Mitigation we write ourselves',
            body: "No resold appliance, no outsourced filtering. Our DPDK/XDP stack handles packets right at the network card, before the system even sees them. That is what lets us tune it for FiveM protocols instead of applying generic rules.",
            points: ['Kernel-space filtering', 'Rules built for FiveM', 'Developed in-house']
          },
          record: {
            kicker: 'In the field',
            title: 'No bypass on FiveM in over a year',
            body: 'Attack methods targeting FiveM move fast. So do ours: every attempt seen on the network feeds back into our rules. The result is twelve-plus months without a bypass getting through.',
            points: ['12+ months with no bypass', 'Rules updated continuously', '24/7 monitoring'],
          },
          monitoring: {
            kicker: 'Monitoring',
            title: 'Every packet, tracked in real time',
            body: 'Our engineers see traffic packet by packet, down to the second. An attack spike is detected and filtered before it gets a chance to affect your server.',
            points: ['Packet-by-packet inspection', 'Alerts within seconds', '24/7 oversight by our engineers'],
          }
        },
        network: {
          kicker: 'Global network',
          title: 'A network close to your players',
          paragraph: 'Your players connect to the nearest point of presence. Traffic is filtered before it reaches your server, whose IP stays hidden.',
          hint: 'Hover a location',
          regions: { europe: 'Europe', northAmerica: 'North America', asia: 'Asia' },
          features: {
            filtering: { title: 'L3 / L4 / L7 filtering', desc: 'XDP mitigation, tuned for FiveM.' },
            anycast: { title: 'Anycast routing', desc: 'Every player reaches the closest PoP.' },
            capacity: { title: '17+ Tbps capacity', desc: 'Massive attacks absorbed without impact.' }
          },
          pops: {
            gravelines: { city: 'Gravelines', country: 'France' },
            frankfurt: { city: 'Frankfurt', country: 'Germany' },
            london: { city: 'London', country: 'United Kingdom' },
            warsaw: { city: 'Warsaw', country: 'Poland' },
            madrid: { city: 'Madrid', country: 'Spain' },
            barcelona: { city: 'Barcelona', country: 'Spain' },
            montreal: { city: 'Montreal', country: 'Canada' },
            toronto: { city: 'Toronto', country: 'Canada' },
            mumbai: { city: 'Mumbai', country: 'India' },
            singapore: { city: 'Singapore', country: 'Singapore' }
          }
        },
        finalCta: {
          title: 'Ready to protect your server?',
          subtitle: 'Join hundreds of FiveM servers that trust us.',
          button: 'Get started now'
        },
        vpsCard: {
          title: 'High-Performance VPS',
          description:
            'High-frequency dedicated servers with 5.20GHz CPU, optimized for FiveM with built-in Anti-DDoS protection.',
          bullets: {
            cpu: 'High-frequency CPU (5.20GHz)',
            storage: 'Ultra-fast NVMe storage',
            ddos: 'DDoS protection included'
          },
          cta: 'Explore our VPS plans'
        },
        vpsWindowsCard: {
          title: 'VPS Windows',
          description:
            'Windows Server 2025 VPS servers with built-in Anti-DDoS protection, ideal for FiveM.',
          bullets: {
            windows: 'Windows Server 2025 included',
            storage: 'Ultra-fast NVMe storage',
            ddos: 'DDoS protection included'
          },
          cta: 'Explore VPS Windows'
        },
        panelCard: {
          title: 'Game Panel',
          description:
            'A turnkey FiveM server, online in under a minute. DDoS protection included, no command line.',
          cta: 'Explore the Game Panel'
        },
        cdnCard: {
          title: 'CDN & Caching',
          description:
            'Speed up how your players connect with our high-performance CDN. Load times cut by 10x.',
          cta: 'Explore the CDN'
        },
        proxyCard: {
          title: 'Reverse Proxy',
          description:
            'Advanced Anti-DDoS protection for your existing FiveM server. Get attacked without compromising stability.',
          bullets: {
            l3l7: 'L3/L4/L7 Protection',
            latency: 'Minimal latency',
            ipMask: 'Full IP masking'
          },
          cta: 'Explore Proxy protection'
        },
        support: {
          title: 'Dedicated Support',
          paragraph:
            'A team of experts available to help you solve problems and answer your questions.'
        },
        standardSupport: {
          title: 'Standard Support',
          paragraph:
            'Our standard support team is available to answer your questions and resolve your issues.',
          bullets: {
            hours: 'Available from 11:00 to 22:00 (UTC)',
            channels: 'Technical assistance by Email and Ticket',
            response: 'Average response time: 1–2 hours'
          },
          note: 'Included with all our standard plans'
        },
        premiumSupport: {
          title: 'Premium Support',
          paragraph: 'Priority assistance available 24/7 for ultra-fast, personalized support.',
          bullets: {
            availability: 'Available 24/7, 365 days a year',
            channels: 'Priority assistance via ticket and chat',
            response: 'Average response time: 5 minutes'
          },
          note: 'Available as an option'
        },
        discord: {
          title: 'Join our Discord community',
          paragraph:
            'Access technical support, connect with our community and stay up to date with our latest news on our official Discord server.',
          cta: 'Join Discord'
        },
        faq: {
          title: 'Frequently Asked Questions about our FiveM services',
          paragraph:
            'Find answers to frequently asked questions about our FiveM hosting and protection',
          q1: {
            title: 'What hosting services does FIVEMSHIELD offer for FiveM?',
            answer:
              'FIVEMSHIELD is a specialized hosting provider for FiveM servers offering high-performance VPS services with 5.20GHz CPUs, fast NVMe storage and built-in Anti-DDoS protection. We also provide reverse proxy services and a management panel to simplify your FiveM server administration.'
          },
          q2: {
            title: 'How does Anti-DDoS protection work for FiveM servers?',
            answer:
              'Our Anti-DDoS protection for FiveM uses a multilayer approach that intelligently filters malicious traffic while allowing legitimate players to access your server without latency. Our system can absorb up to 4.5 Tbps of attacks and provides protection against L3, L4 and L7 threats, specifically tailored to FiveM servers.'
          },
          q3: {
            title: 'Why choose a specialized FiveM host over a standard host?',
            answer:
              'FiveM servers have specific requirements that standard hosts may not always meet. FIVEMSHIELD offers optimized servers with high-frequency CPUs (critical for FiveM), a network architecture designed to reduce latency, and Anti-DDoS protection specifically configured for attack patterns targeting game servers. Our configurations are fully optimized to maximize your FiveM server performance and stability.'
          },
          q4: {
            title: 'Which VPS plan should I choose for my FiveM server?',
            answer:
              'Your VPS choice mainly depends on the number of players you plan to host. For growing communities (30 to 80 players), our StealthEdge plan is ideal. For high-traffic servers (80-150 players), we recommend the StormGuard plan with 8 vCores and 32GB RAM. Large multi-server networks (150+ players) will fully benefit from our TitanShield plan. All our plans include Anti-DDoS protection adapted to your server size.'
          }
        },
        testimonials: {
          badge: 'Client Reviews',
          title: 'Trusted by the Community',
          subtitle: 'Discover what our clients say about protecting their FiveM servers with FIVEMSHIELD.',
          founderPrefix: 'Founder:',
          roleLabel: 'Founder',
          players: 'players',
          heroTitle: 'Authentic Insights',
          heroFrom: 'From our',
          heroBracket: 'Clients',
          allReviews: 'See all our reviews',
          items: {
            server1: 'Service: ⭐️⭐️⭐️⭐️⭐️/5\nSpeed: ⭐️⭐️⭐️⭐️⭐️/5\nPatience: ⭐️⭐️⭐️⭐️⭐️/5\nUnderstanding: ⭐️⭐️⭐️⭐️⭐️/5\nProfessionalism: ⭐️⭐️⭐️⭐️⭐️/5\n\nAlways there when it counts!',
            server2: 'We\'ve had a reverse proxy for a few months now and honestly, their support is just incredible! Fast, efficient, friendly!',
            server3: 'I recently signed up for two services with FIVEMSHIELD: one for server hosting and the other for DDoS protection. What I particularly appreciated was that they are French like me: this makes it much easier to ask questions or request assistance. The team is attentive and responsive. I mainly dealt with Lucas, who was very professional, and I have no doubt that the rest of the team is just as understanding and experienced. We\'ve been using their services for almost a month now, and I have absolutely no complaints: when a problem arises, it\'s resolved in less than five hours. I deliberately took a step back before giving my opinion in order to judge them over the medium/long term, and I am 100% satisfied. If you\'re still hesitating, don\'t wait any longer. As the #1 PvP server, Rush PvP needs stability, and FivemShield has been able to provide it. Thanks again to them.',
            server4: 'Excellent value for money. We went from near-daily crashes to total stability. The reverse proxy works perfectly and the latency is imperceptible.',
            server5: 'The CDN was a game-changer for us. Our resource loading times were divided by 5 and players connect much faster now.',
            server6: 'Service: ⭐️⭐️⭐️⭐️⭐️/5\nSpeed: ⭐️⭐️⭐️⭐️⭐️/5\nPatience: ⭐️⭐️⭐️⭐️⭐️/5\nUnderstanding: ⭐️⭐️⭐️⭐️⭐️/5\nProfessionalism: ⭐️⭐️⭐️⭐️⭐️/5',
            server7: 'Great service and really fast support. Setup was super easy and everything works smoothly.\nHighly recommended 👍\n\nService : ⭐️⭐️⭐️⭐️⭐️/5\nRapidité : ⭐️⭐️⭐️⭐️⭐️/5\nPatience : ⭐️⭐️⭐️⭐️⭐️/5\nCompréhension : ⭐️⭐️⭐️⭐️⭐️/5\nProfessionnalisme : ⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️⭐️/5',
            server8: 'Service : ⭐️⭐️⭐️⭐️⭐️/5\nSupport : ⭐️⭐️⭐️⭐️⭐️/5\n\nVery fast customer support ❤️'
          }
        }
      },
      cdn: {
        breadcrumb: 'CDN & Caching',
        seo: {
          title: 'FiveM CDN Free* | 10x Faster Player Connections',
          description: 'FiveM CDN: players connect 10x faster. 2-line server.cfg setup. Works with any host. Reduce disconnects and loading times instantly.'
        },
        hero: {
          kicker: 'FiveM CDN & Caching',
          title: 'Accelerate your resources and player connections',
          subtitle:
            'Our ultra-fast CDN distributes your FiveM resources worldwide and accelerates player connections. Simple 2-line configuration in your server.cfg.',
          points: [
            'Ultra-simple setup: 2 lines in server.cfg',
            'Drastically reduced resource loading times',
            'Player connections up to 10x faster',
            'Global distribution via our CDN network'
          ],
          stats: [
            { value: '10x', label: 'Faster connection' },
            { value: '< 2 min', label: 'Setup time' },
            { value: '24/7', label: 'Technical support' }
          ],
          ctaPrimary: 'Activate CDN',
          ctaSecondary: 'View documentation',
          cardTitle: 'How does it work?',
          cardSubtitle: 'Our CDN caches your resources and distributes them from our ultra-fast edge servers.',
          cardNote: 'Simply add 2 lines to your server.cfg and instantly enjoy ultra-fast connections for your players.'
        },
        features: {
          kicker: 'Benefits',
          title: 'Why use our CDN?',
          subtitle: 'A solution designed for FiveM with maximum performance.',
          items: [
            {
              title: 'Instant configuration',
              description: 'Add 2 lines to your server.cfg and that\'s it. No modifications to your resources needed.'
            },
            {
              title: 'Ultra-fast connection',
              description: 'Your players connect up to 10x faster thanks to our global distribution network.'
            },
            {
              title: 'Accelerated resources',
              description: 'Instant resource downloads from our edge servers close to your players.'
            },
            {
              title: 'Bandwidth saved',
              description: 'Reduce the load on your server by delegating resource distribution to our CDN.'
            }
          ]
        },
        howItWorks: {
          kicker: 'Simplicity',
          title: '2-line configuration',
          subtitle: 'Activate the CDN in under 2 minutes.',
          steps: [
            {
              title: 'Add 2 lines to server.cfg',
              description: 'Copy the 2 configuration lines we provide and paste them into your server.cfg.',
              code: 'set adhesive_cdnKey "https://caching-cdn.fivemshield.net/files" \nset adhesive_cdnKey "randomKeyHere"'
            },
            {
              title: 'Restart your server',
              description: 'A simple restart is enough to activate the CDN. No other configuration needed.'
            },
            {
              title: 'Enjoy the performance',
              description: 'Your players immediately benefit from ultra-fast connections and instant resource loading.'
            }
          ]
        },
        plans: {
          kicker: 'Pricing',
          title: 'Choose your CDN plan',
          subtitle: 'Plans adapted to your community size.',
          recommended: 'RECOMMENDED',
          select: 'Choose this plan',
          starter: {
            badge: 'Starter',
            price: '€4.99',
            description: 'For small communities getting started. Ideal up to ~48 players.',
            features: [
              'Bandwidth: 2 TB/month',
              'Dedicated cache behind Cloudflare',
              'Real-time traffic statistics',
              'Instant cache purge',
              'Standard support 7/7'
            ]
          },
          pro: {
            badge: 'Professional',
            price: '€14.99',
            description: 'The best choice for growing servers. Ideal up to ~128 players.',
            features: [
              'Bandwidth: 10 TB/month',
              'Dedicated cache behind Cloudflare',
              'Real-time traffic statistics',
              'Instant cache purge',
              'Priority support 24/7'
            ]
          },
          business: {
            badge: 'Business',
            price: '€29.99',
            description: 'For big, high-traffic servers. Ideal up to ~256 players.',
            features: [
              'Bandwidth: 30 TB/month',
              'Dedicated cache behind Cloudflare',
              'Real-time traffic statistics',
              'Instant cache purge',
              'Anycast',
              'Priority support 24/7'
            ]
          },
          enterprise: {
            badge: 'Enterprise',
            price: '€59.99',
            description: 'For large communities and multi-server networks.',
            features: [
              'Bandwidth: 75 TB/month',
              'Dedicated cache behind Cloudflare',
              'Real-time traffic statistics',
              'Instant cache purge',
              'Anycast',
              'Dedicated support 24/7'
            ]
          },
          contact: 'Need a custom solution?',
          contactCta: 'Contact our team'
        },
        benefits: {
          title: 'FIVEMSHIELD CDN advantages',
          subtitle: 'Infrastructure designed for maximum performance.',
          cards: [
            {
              title: 'Global network',
              description: 'Edge servers worldwide for minimal latency everywhere.'
            },
            {
              title: 'Smart caching',
              description: 'Automatic and optimized caching of your FiveM resources.'
            },
            {
              title: 'Real-time monitoring',
              description: 'Complete dashboard to track your CDN usage and performance.'
            }
          ]
        },
        faq: {
          title: 'Frequently asked questions',
          subtitle: 'Everything you need to know about our CDN.',
          items: [
            {
              question: 'How do I activate the CDN on my server?',
              answer:
                'It\'s very simple! Add the 2 configuration lines we provide to your server.cfg, restart your server and that\'s it. The CDN is immediately active.'
            },
            {
              question: 'Do I need to modify my resources?',
              answer:
                'No, no modifications to your resources are needed. Our CDN works transparently with your current configuration.'
            },
            {
              question: 'What\'s the speed difference?',
              answer:
                'On average, our clients see a 70% reduction in player connection time and near-instant resource downloads thanks to our global distribution network.'
            },
            {
              question: 'Can I use the CDN with my current host?',
              answer:
                'Yes, our CDN works with any host. You don\'t need to migrate your server to benefit from our CDN.'
            },
            {
              question: 'What happens if I exceed my bandwidth?',
              answer:
                'We notify you before reaching the limit. You can then upgrade to a higher plan or purchase additional bandwidth on demand.'
            }
          ]
        },
        finalCta: {
          title: 'Accelerate your server today',
          subtitle: '2-minute setup, immediate results.',
          start: 'Activate CDN',
          talk: 'Talk to an expert'
        }
      },
      privacy: {
        seo: {
          title: 'Privacy Policy | FIVEMSHIELD',
          description: 'Privacy policy of FIVEMSHIELD: collection, processing and protection of your personal data in accordance with GDPR.'
        },
        hero: {
          title: 'Privacy',
          titleHighlight: 'Policy',
          subtitle: 'Your personal data deserves to be protected. Learn how FIVEMSHIELD collects, uses and secures your information.'
        },
        lastUpdated: 'Last updated: May 2025',
        sections: {
          controller: {
            title: '1. Data Controller',
            body: 'xdpfilter (SIREN: 943 814 749, SIRET: 94381474900025), headquartered at 78 AVENUE des Champs Élysées, 75008 Paris, France – Office 326, is the data controller for personal data collected through the website fivemshield.net.',
            contact: 'For any questions regarding your data, please contact us at: contact@fivemshield.net'
          },
          collected: {
            title: '2. Data We Collect',
            intro: 'We collect the following data depending on your interactions with our services:',
            categories: [
              {
                label: 'Identification data',
                items: ['First and last name', 'Email address', 'Username / Discord handle']
              },
              {
                label: 'Billing data',
                items: ['Billing address', 'Payment history', 'Transaction ID (processing delegated to Stripe / PayPal)']
              },
              {
                label: 'Technical data',
                items: ['IP address', 'Connection and access logs', 'Information about subscribed services (VPS, Reverse Proxy, CDN, Dedicated Servers)', 'Resource usage metrics (bandwidth, CPU, RAM)']
              },
              {
                label: 'Communication data',
                items: ['Messages sent via the contact form or support tickets', 'Exchanges on Discord / WhatsApp in the context of support']
              }
            ]
          },
          purposes: {
            title: '3. Purposes of Processing',
            intro: 'Your data is processed for the following purposes:',
            list: [
              'Creation and management of your client area (manager.fivemshield.net)',
              'Provision and administration of subscribed services (VPS, Reverse Proxy, CDN, Dedicated Servers)',
              'Billing, payment and accounting management',
              'Prevention of abuse, fraud and malicious activities on our infrastructure',
              'Response to your technical support requests',
              'Sending service notifications (renewal, incidents, maintenance)',
              'Improving our services and user experience',
              'Compliance with our legal obligations'
            ]
          },
          legal: {
            title: '4. Legal Bases (GDPR)',
            intro: 'Processing is based on the following legal grounds under Article 6 of the GDPR:',
            list: [
              { basis: 'Contract performance', detail: 'for managing your account, delivering services and invoicing.' },
              { basis: 'Legitimate interest', detail: 'for preventing abuse, securing infrastructure and improving services.' },
              { basis: 'Legal obligation', detail: 'for retaining billing data and complying with accounting obligations.' },
              { basis: 'Consent', detail: 'for sending marketing or promotional communications (if applicable).' }
            ]
          },
          retention: {
            title: '5. Data Retention',
            list: [
              { type: 'Client account data', duration: 'For the entire duration of account activity, then 3 years after termination.' },
              { type: 'Billing data', duration: '10 years (legal accounting obligation).' },
              { type: 'Technical logs', duration: 'Maximum 12 months.' },
              { type: 'Support tickets', duration: '2 years from the closure of the ticket.' }
            ]
          },
          sharing: {
            title: '6. Data Sharing',
            intro: 'FIVEMSHIELD never sells your data to third parties. Your data may only be shared with:',
            list: [
              { name: 'Payment providers', detail: 'Stripe, PayPal — for secure transaction processing.' },
              { name: 'Infrastructure providers', detail: 'Our datacenter partners (OVH, Hetzner, etc.) — for providing server resources.' },
              { name: 'Analytics tools', detail: 'Internal tools only (Grafana) — for service monitoring, without transfer to advertising third parties.' }
            ],
            gdpr: 'All sub-processors are bound by a contract ensuring GDPR compliance.'
          },
          international: {
            title: '7. International Transfers',
            body: 'Some infrastructure may be located outside the European Union (e.g. North America, Asia). In such cases, FIVEMSHIELD ensures that data transfers are governed by appropriate safeguards (European Commission standard contractual clauses or adequacy decision).'
          },
          rights: {
            title: '8. Your Rights',
            intro: 'Under the GDPR, you have the following rights:',
            list: [
              { right: 'Right of access', detail: 'obtain a copy of your personal data.' },
              { right: 'Right of rectification', detail: 'correct inaccurate or incomplete data.' },
              { right: 'Right to erasure', detail: 'request deletion of your data (subject to legal obligations).' },
              { right: 'Right to restriction', detail: 'restrict the processing of your data in certain circumstances.' },
              { right: 'Right to portability', detail: 'receive your data in a structured, machine-readable format.' },
              { right: 'Right to object', detail: 'object to processing based on legitimate interest.' },
              { right: 'Right to withdraw consent', detail: 'withdraw your consent at any time.' }
            ],
            exercise: 'To exercise your rights, send your request to contact@fivemshield.net. We are committed to responding within 30 days.',
            cnil: 'You also have the right to lodge a complaint with your national supervisory authority (in France: www.cnil.fr).'
          },
          cookies: {
            title: '9. Cookies',
            body: 'The website fivemshield.net uses only strictly necessary cookies for the website to function (session, language preference) and anonymised performance analytics cookies. No advertising or third-party tracking cookies are placed without your explicit consent.'
          },
          security: {
            title: '10. Data Security',
            body: 'FIVEMSHIELD implements appropriate technical and organisational measures to protect your data against any unauthorised access, loss or disclosure: TLS encryption of communications, restricted access to data by our team, continuous infrastructure monitoring.'
          },
          changes: {
            title: '11. Changes',
            body: 'This policy may be updated at any time. In the event of a material change, we will inform you by email or via a notification on the site. The date of last update is shown at the top of this page.'
          },
          contact: {
            title: '12. Contact',
            body: 'For any questions regarding this privacy policy or the exercise of your rights, please contact us:',
            email: 'contact@fivemshield.net',
            address: 'xdpfilter — 78 AVENUE des Champs Élysées, 75008 Paris, France – Bureau 326'
          }
        },
        links: {
          intro: 'Also read our',
          legal: 'Terms & Conditions',
          about: 'About',
          contact: 'Contact'
        }
      }
    }
  }
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: ['translation'],
    defaultNS: 'translation',
    fallbackLng: 'en',
    supportedLngs: ['fr', 'en'],
    load: 'languageOnly',
    initImmediate: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      // Order: user preference, querystring, cookie, localStorage, navigator, html tag
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie']
    }
  })
  .then(() => {
    // If not resolved to fr/en by detector, optionally refine via GeoIP
    const lang = i18next.language?.slice(0, 2);
    if (!lang || !['fr', 'en'].includes(lang)) {
      try {
        fetch('https://ipapi.co/json/')
          .then((res) => res.json())
          .then((data) => {
            const country: string | undefined = data?.country;
            const frCountries = new Set([
              'FR', 'BE', 'CA', 'CH', 'LU', 'MC',
              'GP', 'MQ', 'RE', 'YT', 'NC', 'PF', 'WF', 'PM', 'BL', 'MF'
            ]);
            const picked = country && frCountries.has(country) ? 'fr' : 'en';
            i18next.changeLanguage(picked);
          })
          .catch(() => void 0);
      } catch (_) {
        // noop
      }
    }
  });

export default i18next;


